"use strict";
/**
 * LucidLink Service API Reference
 * The LucidLink API is organized around REST. The API has predictable resource-oriented URLs, works with JSON-encoded request and response bodies and uses standard-based verbs (HTTP), responses and authentication. The authentication uses OAuth2 Client Credentials Grant Type. The credentials are provided upon request sent to `support@lucidlink.com`.
 *
 * OpenAPI spec version: 1.0.0
 *
 *
 * NOTE: This class is auto generated by the swagger code generator program.
 * https://github.com/swagger-api/swagger-codegen.git
 * Do not edit the class manually.
 */
Object.defineProperty(exports, "__esModule", { value: true });
var localVarRequest = require("request");
var Promise = require("bluebird");
var defaultBasePath = 'https://localhost/api/v1';
// ===============================================
// This file is autogenerated - Please do not edit
// ===============================================
/* tslint:disable:no-unused-variable */
var primitives = [
    "string",
    "boolean",
    "double",
    "integer",
    "long",
    "float",
    "number",
    "any"
];
var ObjectSerializer = /** @class */ (function () {
    function ObjectSerializer() {
    }
    ObjectSerializer.findCorrectType = function (data, expectedType) {
        if (data == undefined) {
            return expectedType;
        }
        else if (primitives.indexOf(expectedType.toLowerCase()) !== -1) {
            return expectedType;
        }
        else if (expectedType === "Date") {
            return expectedType;
        }
        else {
            if (enumsMap[expectedType]) {
                return expectedType;
            }
            if (!typeMap[expectedType]) {
                return expectedType; // w/e we don't know the type
            }
            // Check the discriminator
            var discriminatorProperty = typeMap[expectedType].discriminator;
            if (discriminatorProperty == null) {
                return expectedType; // the type does not have a discriminator. use it.
            }
            else {
                if (data[discriminatorProperty]) {
                    return data[discriminatorProperty]; // use the type given in the discriminator
                }
                else {
                    return expectedType; // discriminator was not present (or an empty string)
                }
            }
        }
    };
    ObjectSerializer.serialize = function (data, type) {
        if (data == undefined) {
            return data;
        }
        else if (primitives.indexOf(type.toLowerCase()) !== -1) {
            return data;
        }
        else if (type.lastIndexOf("Array<", 0) === 0) {
            var subType = type.replace("Array<", ""); // Array<Type> => Type>
            subType = subType.substring(0, subType.length - 1); // Type> => Type
            var transformedData = [];
            for (var index in data) {
                var date = data[index];
                transformedData.push(ObjectSerializer.serialize(date, subType));
            }
            return transformedData;
        }
        else if (type === "Date") {
            return data.toString();
        }
        else {
            if (enumsMap[type]) {
                return data;
            }
            if (!typeMap[type]) {
                return data;
            }
            // get the map for the correct type.
            var attributeTypes = typeMap[type].getAttributeTypeMap();
            var instance = {};
            for (var index in attributeTypes) {
                var attributeType = attributeTypes[index];
                instance[attributeType.baseName] = ObjectSerializer.serialize(data[attributeType.name], attributeType.type);
            }
            return instance;
        }
    };
    ObjectSerializer.deserialize = function (data, type) {
        // polymorphism may change the actual type.
        type = ObjectSerializer.findCorrectType(data, type);
        if (data == undefined) {
            return data;
        }
        else if (primitives.indexOf(type.toLowerCase()) !== -1) {
            return data;
        }
        else if (type.lastIndexOf("Array<", 0) === 0) {
            var subType = type.replace("Array<", ""); // Array<Type> => Type>
            subType = subType.substring(0, subType.length - 1); // Type> => Type
            var transformedData = [];
            for (var index in data) {
                var date = data[index];
                transformedData.push(ObjectSerializer.deserialize(date, subType));
            }
            return transformedData;
        }
        else if (type === "Date") {
            return new Date(data);
        }
        else {
            if (enumsMap[type]) {
                return data;
            }
            if (!typeMap[type]) {
                return data;
            }
            var instance = new typeMap[type]();
            var attributeTypes = typeMap[type].getAttributeTypeMap();
            for (var index in attributeTypes) {
                var attributeType = attributeTypes[index];
                instance[attributeType.name] = ObjectSerializer.deserialize(data[attributeType.baseName], attributeType.type);
            }
            return instance;
        }
    };
    return ObjectSerializer;
}());
var AccountSettings = /** @class */ (function () {
    function AccountSettings() {
    }
    AccountSettings.getAttributeTypeMap = function () {
        return AccountSettings.attributeTypeMap;
    };
    AccountSettings.discriminator = undefined;
    AccountSettings.attributeTypeMap = [
        {
            "name": "userId",
            "baseName": "userId",
            "type": "string"
        },
        {
            "name": "isSuspended",
            "baseName": "isSuspended",
            "type": "boolean"
        },
        {
            "name": "securityScopes",
            "baseName": "securityScopes",
            "type": "Array<string>"
        },
        {
            "name": "transitionType",
            "baseName": "transitionType",
            "type": "AccountSettings.TransitionTypeEnum"
        }
    ];
    return AccountSettings;
}());
exports.AccountSettings = AccountSettings;
(function (AccountSettings) {
    var TransitionTypeEnum;
    (function (TransitionTypeEnum) {
        TransitionTypeEnum[TransitionTypeEnum["V3ToV4"] = 'V3ToV4'] = "V3ToV4";
        TransitionTypeEnum[TransitionTypeEnum["None"] = 'None'] = "None";
    })(TransitionTypeEnum = AccountSettings.TransitionTypeEnum || (AccountSettings.TransitionTypeEnum = {}));
})(AccountSettings = exports.AccountSettings || (exports.AccountSettings = {}));
exports.AccountSettings = AccountSettings;
var AdminStatusRequired = /** @class */ (function () {
    function AdminStatusRequired() {
    }
    AdminStatusRequired.getAttributeTypeMap = function () {
        return AdminStatusRequired.attributeTypeMap;
    };
    AdminStatusRequired.discriminator = undefined;
    AdminStatusRequired.attributeTypeMap = [
        {
            "name": "status",
            "baseName": "status",
            "type": "number"
        },
        {
            "name": "message",
            "baseName": "message",
            "type": "string"
        }
    ];
    return AdminStatusRequired;
}());
exports.AdminStatusRequired = AdminStatusRequired;
var AdminUserSearchResult = /** @class */ (function () {
    function AdminUserSearchResult() {
    }
    AdminUserSearchResult.getAttributeTypeMap = function () {
        return AdminUserSearchResult.attributeTypeMap;
    };
    AdminUserSearchResult.discriminator = undefined;
    AdminUserSearchResult.attributeTypeMap = [
        {
            "name": "id",
            "baseName": "id",
            "type": "string"
        },
        {
            "name": "isSuspended",
            "baseName": "isSuspended",
            "type": "boolean"
        },
        {
            "name": "identityProviders",
            "baseName": "identityProviders",
            "type": "string"
        },
        {
            "name": "email",
            "baseName": "email",
            "type": "string"
        },
        {
            "name": "created",
            "baseName": "created",
            "type": "number"
        },
        {
            "name": "isAccountTrial",
            "baseName": "isAccountTrial",
            "type": "boolean"
        },
        {
            "name": "hasApiKey",
            "baseName": "hasApiKey",
            "type": "boolean"
        }
    ];
    return AdminUserSearchResult;
}());
exports.AdminUserSearchResult = AdminUserSearchResult;
var AppcuesData = /** @class */ (function () {
    function AppcuesData() {
    }
    AppcuesData.getAttributeTypeMap = function () {
        return AppcuesData.attributeTypeMap;
    };
    AppcuesData.discriminator = undefined;
    AppcuesData.attributeTypeMap = [
        {
            "name": "id",
            "baseName": "id",
            "type": "string"
        },
        {
            "name": "createdAt",
            "baseName": "createdAt",
            "type": "number"
        },
        {
            "name": "isTrial",
            "baseName": "isTrial",
            "type": "boolean"
        },
        {
            "name": "isSuspended",
            "baseName": "isSuspended",
            "type": "boolean"
        },
        {
            "name": "isCreditCardEntered",
            "baseName": "isCreditCardEntered",
            "type": "boolean"
        },
        {
            "name": "isAlternativePaymentEntered",
            "baseName": "isAlternativePaymentEntered",
            "type": "boolean"
        },
        {
            "name": "isBillingAddressEntered",
            "baseName": "isBillingAddressEntered",
            "type": "boolean"
        }
    ];
    return AppcuesData;
}());
exports.AppcuesData = AppcuesData;
var Attributes = /** @class */ (function () {
    function Attributes() {
    }
    Attributes.getAttributeTypeMap = function () {
        return Attributes.attributeTypeMap;
    };
    Attributes.discriminator = undefined;
    Attributes.attributeTypeMap = [
        {
            "name": "firstName",
            "baseName": "firstName",
            "type": "string"
        },
        {
            "name": "lastName",
            "baseName": "lastName",
            "type": "string"
        },
        {
            "name": "phoneNumber",
            "baseName": "phoneNumber",
            "type": "string"
        },
        {
            "name": "title",
            "baseName": "title",
            "type": "string"
        },
        {
            "name": "companyName",
            "baseName": "companyName",
            "type": "string"
        },
        {
            "name": "partnerSource",
            "baseName": "partnerSource",
            "type": "string"
        },
        {
            "name": "utmData",
            "baseName": "utmData",
            "type": "UtmData"
        },
        {
            "name": "googleClickId",
            "baseName": "googleClickId",
            "type": "string"
        },
        {
            "name": "facebookClickId",
            "baseName": "facebookClickId",
            "type": "string"
        },
        {
            "name": "linkedInFatId",
            "baseName": "linkedInFatId",
            "type": "string"
        },
        {
            "name": "fbp",
            "baseName": "fbp",
            "type": "string"
        },
        {
            "name": "userAgent",
            "baseName": "userAgent",
            "type": "string"
        }
    ];
    return Attributes;
}());
exports.Attributes = Attributes;
var BadRequest = /** @class */ (function () {
    function BadRequest() {
    }
    BadRequest.getAttributeTypeMap = function () {
        return BadRequest.attributeTypeMap;
    };
    BadRequest.discriminator = undefined;
    BadRequest.attributeTypeMap = [
        {
            "name": "status",
            "baseName": "status",
            "type": "number"
        },
        {
            "name": "message",
            "baseName": "message",
            "type": "string"
        }
    ];
    return BadRequest;
}());
exports.BadRequest = BadRequest;
var BillingAddress = /** @class */ (function () {
    function BillingAddress() {
    }
    BillingAddress.getAttributeTypeMap = function () {
        return BillingAddress.attributeTypeMap;
    };
    BillingAddress.discriminator = undefined;
    BillingAddress.attributeTypeMap = [
        {
            "name": "line1",
            "baseName": "line1",
            "type": "string"
        },
        {
            "name": "line2",
            "baseName": "line2",
            "type": "string"
        },
        {
            "name": "city",
            "baseName": "city",
            "type": "string"
        },
        {
            "name": "country",
            "baseName": "country",
            "type": "string"
        },
        {
            "name": "postalCode",
            "baseName": "postal_code",
            "type": "string"
        },
        {
            "name": "state",
            "baseName": "state",
            "type": "string"
        }
    ];
    return BillingAddress;
}());
exports.BillingAddress = BillingAddress;
var BillingPeriod = /** @class */ (function () {
    function BillingPeriod() {
    }
    BillingPeriod.getAttributeTypeMap = function () {
        return BillingPeriod.attributeTypeMap;
    };
    BillingPeriod.discriminator = undefined;
    BillingPeriod.attributeTypeMap = [
        {
            "name": "start",
            "baseName": "start",
            "type": "number"
        },
        {
            "name": "end",
            "baseName": "end",
            "type": "number"
        },
        {
            "name": "subscriptionStatus",
            "baseName": "subscriptionStatus",
            "type": "string"
        },
        {
            "name": "amountDue",
            "baseName": "amountDue",
            "type": "number"
        },
        {
            "name": "amountDueForecast",
            "baseName": "amountDueForecast",
            "type": "number"
        },
        {
            "name": "currency",
            "baseName": "currency",
            "type": "string"
        },
        {
            "name": "trialDays",
            "baseName": "trialDays",
            "type": "number"
        },
        {
            "name": "filespaceBreakdown",
            "baseName": "filespaceBreakdown",
            "type": "Array<FilespaceLineItemWithForecast>"
        }
    ];
    return BillingPeriod;
}());
exports.BillingPeriod = BillingPeriod;
var BillingPlan = /** @class */ (function () {
    function BillingPlan() {
    }
    BillingPlan.getAttributeTypeMap = function () {
        return BillingPlan.attributeTypeMap;
    };
    BillingPlan.discriminator = undefined;
    BillingPlan.attributeTypeMap = [
        {
            "name": "id",
            "baseName": "id",
            "type": "string"
        },
        {
            "name": "name",
            "baseName": "name",
            "type": "string"
        },
        {
            "name": "planPackages",
            "baseName": "planPackages",
            "type": "Array<PlanPackage>"
        },
        {
            "name": "isCustomPricing",
            "baseName": "isCustomPricing",
            "type": "boolean"
        }
    ];
    return BillingPlan;
}());
exports.BillingPlan = BillingPlan;
var BillingPlanUpdate = /** @class */ (function () {
    function BillingPlanUpdate() {
    }
    BillingPlanUpdate.getAttributeTypeMap = function () {
        return BillingPlanUpdate.attributeTypeMap;
    };
    BillingPlanUpdate.discriminator = undefined;
    BillingPlanUpdate.attributeTypeMap = [
        {
            "name": "id",
            "baseName": "id",
            "type": "string"
        },
        {
            "name": "planPackageUpdates",
            "baseName": "planPackageUpdates",
            "type": "Array<PlanPackageUpdate>"
        }
    ];
    return BillingPlanUpdate;
}());
exports.BillingPlanUpdate = BillingPlanUpdate;
var Card = /** @class */ (function () {
    function Card() {
    }
    Card.getAttributeTypeMap = function () {
        return Card.attributeTypeMap;
    };
    Card.discriminator = undefined;
    Card.attributeTypeMap = [
        {
            "name": "numberLast4",
            "baseName": "numberLast4",
            "type": "string"
        },
        {
            "name": "expiryMonth",
            "baseName": "expiryMonth",
            "type": "number"
        },
        {
            "name": "expiryYear",
            "baseName": "expiryYear",
            "type": "number"
        }
    ];
    return Card;
}());
exports.Card = Card;
var CertificateSigningRequest = /** @class */ (function () {
    function CertificateSigningRequest() {
    }
    CertificateSigningRequest.getAttributeTypeMap = function () {
        return CertificateSigningRequest.attributeTypeMap;
    };
    CertificateSigningRequest.discriminator = undefined;
    CertificateSigningRequest.attributeTypeMap = [
        {
            "name": "csr",
            "baseName": "csr",
            "type": "string"
        }
    ];
    return CertificateSigningRequest;
}());
exports.CertificateSigningRequest = CertificateSigningRequest;
var CertificateSigningResponse = /** @class */ (function () {
    function CertificateSigningResponse() {
    }
    CertificateSigningResponse.getAttributeTypeMap = function () {
        return CertificateSigningResponse.attributeTypeMap;
    };
    CertificateSigningResponse.discriminator = undefined;
    CertificateSigningResponse.attributeTypeMap = [
        {
            "name": "cert",
            "baseName": "cert",
            "type": "string"
        }
    ];
    return CertificateSigningResponse;
}());
exports.CertificateSigningResponse = CertificateSigningResponse;
var CognitoIdToken = /** @class */ (function () {
    function CognitoIdToken() {
    }
    CognitoIdToken.getAttributeTypeMap = function () {
        return CognitoIdToken.attributeTypeMap;
    };
    CognitoIdToken.discriminator = undefined;
    CognitoIdToken.attributeTypeMap = [
        {
            "name": "email",
            "baseName": "email",
            "type": "string"
        },
        {
            "name": "sub",
            "baseName": "sub",
            "type": "string"
        },
        {
            "name": "cognitoUsername",
            "baseName": "cognitoUsername",
            "type": "string"
        },
        {
            "name": "firstName",
            "baseName": "firstName",
            "type": "string"
        },
        {
            "name": "lastName",
            "baseName": "lastName",
            "type": "string"
        },
        {
            "name": "phoneNumber",
            "baseName": "phoneNumber",
            "type": "string"
        },
        {
            "name": "title",
            "baseName": "title",
            "type": "string"
        },
        {
            "name": "companyName",
            "baseName": "companyName",
            "type": "string"
        }
    ];
    return CognitoIdToken;
}());
exports.CognitoIdToken = CognitoIdToken;
var Conflict = /** @class */ (function () {
    function Conflict() {
    }
    Conflict.getAttributeTypeMap = function () {
        return Conflict.attributeTypeMap;
    };
    Conflict.discriminator = undefined;
    Conflict.attributeTypeMap = [
        {
            "name": "status",
            "baseName": "status",
            "type": "number"
        },
        {
            "name": "message",
            "baseName": "message",
            "type": "string"
        }
    ];
    return Conflict;
}());
exports.Conflict = Conflict;
var DimensionLimit = /** @class */ (function () {
    function DimensionLimit() {
    }
    DimensionLimit.getAttributeTypeMap = function () {
        return DimensionLimit.attributeTypeMap;
    };
    DimensionLimit.discriminator = undefined;
    DimensionLimit.attributeTypeMap = [
        {
            "name": "dimension",
            "baseName": "dimension",
            "type": "DimensionLimit.DimensionEnum"
        },
        {
            "name": "reportThreshold",
            "baseName": "reportThreshold",
            "type": "number"
        },
        {
            "name": "maxLimit",
            "baseName": "maxLimit",
            "type": "number"
        },
        {
            "name": "minReportValue",
            "baseName": "minReportValue",
            "type": "number"
        }
    ];
    return DimensionLimit;
}());
exports.DimensionLimit = DimensionLimit;
(function (DimensionLimit) {
    var DimensionEnum;
    (function (DimensionEnum) {
        DimensionEnum[DimensionEnum["Capacity"] = 'Capacity'] = "Capacity";
        DimensionEnum[DimensionEnum["ConnectedDevices"] = 'ConnectedDevices'] = "ConnectedDevices";
        DimensionEnum[DimensionEnum["FilespaceDays"] = 'FilespaceDays'] = "FilespaceDays";
        DimensionEnum[DimensionEnum["Storage"] = 'Storage'] = "Storage";
        DimensionEnum[DimensionEnum["ManagedCapacity"] = 'ManagedCapacity'] = "ManagedCapacity";
        DimensionEnum[DimensionEnum["Egress"] = 'Egress'] = "Egress";
        DimensionEnum[DimensionEnum["FilespaceUsers"] = 'FilespaceUsers'] = "FilespaceUsers";
    })(DimensionEnum = DimensionLimit.DimensionEnum || (DimensionLimit.DimensionEnum = {}));
})(DimensionLimit = exports.DimensionLimit || (exports.DimensionLimit = {}));
exports.DimensionLimit = DimensionLimit;
var Domain = /** @class */ (function () {
    function Domain() {
    }
    Domain.getAttributeTypeMap = function () {
        return Domain.attributeTypeMap;
    };
    Domain.discriminator = undefined;
    Domain.attributeTypeMap = [
        {
            "name": "id",
            "baseName": "id",
            "type": "string"
        },
        {
            "name": "name",
            "baseName": "name",
            "type": "string"
        }
    ];
    return Domain;
}());
exports.Domain = Domain;
var DomainWithFilespaces = /** @class */ (function () {
    function DomainWithFilespaces() {
    }
    DomainWithFilespaces.getAttributeTypeMap = function () {
        return DomainWithFilespaces.attributeTypeMap;
    };
    DomainWithFilespaces.discriminator = undefined;
    DomainWithFilespaces.attributeTypeMap = [
        {
            "name": "name",
            "baseName": "name",
            "type": "string"
        },
        {
            "name": "filespaces",
            "baseName": "filespaces",
            "type": "Array<FilespaceExtended>"
        }
    ];
    return DomainWithFilespaces;
}());
exports.DomainWithFilespaces = DomainWithFilespaces;
var Event = /** @class */ (function () {
    function Event() {
    }
    Event.getAttributeTypeMap = function () {
        return Event.attributeTypeMap;
    };
    Event.discriminator = undefined;
    Event.attributeTypeMap = [
        {
            "name": "message",
            "baseName": "message",
            "type": "string"
        },
        {
            "name": "eventType",
            "baseName": "eventType",
            "type": "Event.EventTypeEnum"
        },
        {
            "name": "logType",
            "baseName": "logType",
            "type": "Event.LogTypeEnum"
        }
    ];
    return Event;
}());
exports.Event = Event;
(function (Event) {
    var EventTypeEnum;
    (function (EventTypeEnum) {
        EventTypeEnum[EventTypeEnum["Filespace"] = 'filespace'] = "Filespace";
        EventTypeEnum[EventTypeEnum["Generic"] = 'generic'] = "Generic";
        EventTypeEnum[EventTypeEnum["Signups"] = 'signups'] = "Signups";
    })(EventTypeEnum = Event.EventTypeEnum || (Event.EventTypeEnum = {}));
    var LogTypeEnum;
    (function (LogTypeEnum) {
        LogTypeEnum[LogTypeEnum["Log"] = 'log'] = "Log";
        LogTypeEnum[LogTypeEnum["Error"] = 'error'] = "Error";
    })(LogTypeEnum = Event.LogTypeEnum || (Event.LogTypeEnum = {}));
})(Event = exports.Event || (exports.Event = {}));
exports.Event = Event;
var Filespace = /** @class */ (function () {
    function Filespace() {
    }
    Filespace.getAttributeTypeMap = function () {
        return Filespace.attributeTypeMap;
    };
    Filespace.discriminator = undefined;
    Filespace.attributeTypeMap = [
        {
            "name": "id",
            "baseName": "id",
            "type": "string"
        },
        {
            "name": "domain",
            "baseName": "domain",
            "type": "string"
        },
        {
            "name": "isSuspended",
            "baseName": "isSuspended",
            "type": "boolean"
        },
        {
            "name": "name",
            "baseName": "name",
            "type": "string"
        },
        {
            "name": "subscriptionType",
            "baseName": "subscriptionType",
            "type": "Filespace.SubscriptionTypeEnum"
        },
        {
            "name": "type",
            "baseName": "type",
            "type": "Filespace.TypeEnum"
        },
        {
            "name": "status",
            "baseName": "status",
            "type": "Filespace.StatusEnum"
        },
        {
            "name": "renameStatus",
            "baseName": "renameStatus",
            "type": "Filespace.RenameStatusEnum"
        },
        {
            "name": "suspensionStatus",
            "baseName": "suspensionStatus",
            "type": "Filespace.SuspensionStatusEnum"
        },
        {
            "name": "version",
            "baseName": "version",
            "type": "number"
        },
        {
            "name": "storage",
            "baseName": "storage",
            "type": "FilespaceStorage"
        },
        {
            "name": "stats",
            "baseName": "stats",
            "type": "any"
        },
        {
            "name": "usersCount",
            "baseName": "usersCount",
            "type": "number"
        }
    ];
    return Filespace;
}());
exports.Filespace = Filespace;
(function (Filespace) {
    var SubscriptionTypeEnum;
    (function (SubscriptionTypeEnum) {
        SubscriptionTypeEnum[SubscriptionTypeEnum["Basic"] = 'basic'] = "Basic";
        SubscriptionTypeEnum[SubscriptionTypeEnum["Teams"] = 'teams'] = "Teams";
        SubscriptionTypeEnum[SubscriptionTypeEnum["Advanced"] = 'advanced'] = "Advanced";
        SubscriptionTypeEnum[SubscriptionTypeEnum["Enterprise"] = 'enterprise'] = "Enterprise";
        SubscriptionTypeEnum[SubscriptionTypeEnum["Custom"] = 'custom'] = "Custom";
        SubscriptionTypeEnum[SubscriptionTypeEnum["None"] = 'none'] = "None";
    })(SubscriptionTypeEnum = Filespace.SubscriptionTypeEnum || (Filespace.SubscriptionTypeEnum = {}));
    var TypeEnum;
    (function (TypeEnum) {
        TypeEnum[TypeEnum["Sandbox"] = 'sandbox'] = "Sandbox";
        TypeEnum[TypeEnum["Unlimited"] = 'unlimited'] = "Unlimited";
        TypeEnum[TypeEnum["V4beta"] = 'v4beta'] = "V4beta";
    })(TypeEnum = Filespace.TypeEnum || (Filespace.TypeEnum = {}));
    var StatusEnum;
    (function (StatusEnum) {
        StatusEnum[StatusEnum["Provisioning"] = 'provisioning'] = "Provisioning";
        StatusEnum[StatusEnum["Provisioned"] = 'provisioned'] = "Provisioned";
        StatusEnum[StatusEnum["Initialized"] = 'initialized'] = "Initialized";
        StatusEnum[StatusEnum["Errored"] = 'errored'] = "Errored";
    })(StatusEnum = Filespace.StatusEnum || (Filespace.StatusEnum = {}));
    var RenameStatusEnum;
    (function (RenameStatusEnum) {
        RenameStatusEnum[RenameStatusEnum["Success"] = 'success'] = "Success";
        RenameStatusEnum[RenameStatusEnum["Errored"] = 'errored'] = "Errored";
        RenameStatusEnum[RenameStatusEnum["Inprogress"] = 'inprogress'] = "Inprogress";
    })(RenameStatusEnum = Filespace.RenameStatusEnum || (Filespace.RenameStatusEnum = {}));
    var SuspensionStatusEnum;
    (function (SuspensionStatusEnum) {
        SuspensionStatusEnum[SuspensionStatusEnum["Suspending"] = 'suspending'] = "Suspending";
        SuspensionStatusEnum[SuspensionStatusEnum["Suspended"] = 'suspended'] = "Suspended";
        SuspensionStatusEnum[SuspensionStatusEnum["SuspensionFailed"] = 'suspension_failed'] = "SuspensionFailed";
        SuspensionStatusEnum[SuspensionStatusEnum["Unsuspending"] = 'unsuspending'] = "Unsuspending";
        SuspensionStatusEnum[SuspensionStatusEnum["UnsuspensionFailed"] = 'unsuspension_failed'] = "UnsuspensionFailed";
        SuspensionStatusEnum[SuspensionStatusEnum["NotSuspended"] = 'not_suspended'] = "NotSuspended";
        SuspensionStatusEnum[SuspensionStatusEnum["Errored"] = 'errored'] = "Errored";
    })(SuspensionStatusEnum = Filespace.SuspensionStatusEnum || (Filespace.SuspensionStatusEnum = {}));
})(Filespace = exports.Filespace || (exports.Filespace = {}));
exports.Filespace = Filespace;
var FilespaceAuth = /** @class */ (function () {
    function FilespaceAuth() {
    }
    FilespaceAuth.getAttributeTypeMap = function () {
        return FilespaceAuth.attributeTypeMap;
    };
    FilespaceAuth.discriminator = undefined;
    FilespaceAuth.attributeTypeMap = [
        {
            "name": "verificationType",
            "baseName": "verificationType",
            "type": "FilespaceAuth.VerificationTypeEnum"
        },
        {
            "name": "id",
            "baseName": "id",
            "type": "string"
        },
        {
            "name": "operationType",
            "baseName": "operationType",
            "type": "FilespaceAuth.OperationTypeEnum"
        }
    ];
    return FilespaceAuth;
}());
exports.FilespaceAuth = FilespaceAuth;
(function (FilespaceAuth) {
    var VerificationTypeEnum;
    (function (VerificationTypeEnum) {
        VerificationTypeEnum[VerificationTypeEnum["Email"] = 'email'] = "Email";
    })(VerificationTypeEnum = FilespaceAuth.VerificationTypeEnum || (FilespaceAuth.VerificationTypeEnum = {}));
    var OperationTypeEnum;
    (function (OperationTypeEnum) {
        OperationTypeEnum[OperationTypeEnum["Delete"] = 'delete'] = "Delete";
        OperationTypeEnum[OperationTypeEnum["Rename"] = 'rename'] = "Rename";
    })(OperationTypeEnum = FilespaceAuth.OperationTypeEnum || (FilespaceAuth.OperationTypeEnum = {}));
})(FilespaceAuth = exports.FilespaceAuth || (exports.FilespaceAuth = {}));
exports.FilespaceAuth = FilespaceAuth;
var FilespaceDeleteAuth = /** @class */ (function () {
    function FilespaceDeleteAuth() {
    }
    FilespaceDeleteAuth.getAttributeTypeMap = function () {
        return FilespaceDeleteAuth.attributeTypeMap;
    };
    FilespaceDeleteAuth.discriminator = undefined;
    FilespaceDeleteAuth.attributeTypeMap = [
        {
            "name": "verificationType",
            "baseName": "verificationType",
            "type": "FilespaceDeleteAuth.VerificationTypeEnum"
        },
        {
            "name": "id",
            "baseName": "id",
            "type": "string"
        }
    ];
    return FilespaceDeleteAuth;
}());
exports.FilespaceDeleteAuth = FilespaceDeleteAuth;
(function (FilespaceDeleteAuth) {
    var VerificationTypeEnum;
    (function (VerificationTypeEnum) {
        VerificationTypeEnum[VerificationTypeEnum["Email"] = 'email'] = "Email";
    })(VerificationTypeEnum = FilespaceDeleteAuth.VerificationTypeEnum || (FilespaceDeleteAuth.VerificationTypeEnum = {}));
})(FilespaceDeleteAuth = exports.FilespaceDeleteAuth || (exports.FilespaceDeleteAuth = {}));
exports.FilespaceDeleteAuth = FilespaceDeleteAuth;
var FilespaceLineItem = /** @class */ (function () {
    function FilespaceLineItem() {
    }
    FilespaceLineItem.getAttributeTypeMap = function () {
        return FilespaceLineItem.attributeTypeMap;
    };
    FilespaceLineItem.discriminator = undefined;
    FilespaceLineItem.attributeTypeMap = [
        {
            "name": "filespace",
            "baseName": "filespace",
            "type": "string"
        },
        {
            "name": "amountDue",
            "baseName": "amountDue",
            "type": "number"
        },
        {
            "name": "isDeleted",
            "baseName": "isDeleted",
            "type": "boolean"
        },
        {
            "name": "name",
            "baseName": "name",
            "type": "string"
        },
        {
            "name": "storageProvider",
            "baseName": "storageProvider",
            "type": "string"
        },
        {
            "name": "storageOwner",
            "baseName": "storageOwner",
            "type": "FilespaceLineItem.StorageOwnerEnum"
        },
        {
            "name": "subscriptionType",
            "baseName": "subscriptionType",
            "type": "FilespaceLineItem.SubscriptionTypeEnum"
        },
        {
            "name": "usageByDimension",
            "baseName": "usageByDimension",
            "type": "Array<FilespaceUsage>"
        }
    ];
    return FilespaceLineItem;
}());
exports.FilespaceLineItem = FilespaceLineItem;
(function (FilespaceLineItem) {
    var StorageOwnerEnum;
    (function (StorageOwnerEnum) {
        StorageOwnerEnum[StorageOwnerEnum["Lucidlink"] = 'lucidlink'] = "Lucidlink";
        StorageOwnerEnum[StorageOwnerEnum["Customer"] = 'customer'] = "Customer";
    })(StorageOwnerEnum = FilespaceLineItem.StorageOwnerEnum || (FilespaceLineItem.StorageOwnerEnum = {}));
    var SubscriptionTypeEnum;
    (function (SubscriptionTypeEnum) {
        SubscriptionTypeEnum[SubscriptionTypeEnum["Basic"] = 'basic'] = "Basic";
        SubscriptionTypeEnum[SubscriptionTypeEnum["Teams"] = 'teams'] = "Teams";
        SubscriptionTypeEnum[SubscriptionTypeEnum["Advanced"] = 'advanced'] = "Advanced";
        SubscriptionTypeEnum[SubscriptionTypeEnum["Enterprise"] = 'enterprise'] = "Enterprise";
        SubscriptionTypeEnum[SubscriptionTypeEnum["Custom"] = 'custom'] = "Custom";
        SubscriptionTypeEnum[SubscriptionTypeEnum["None"] = 'none'] = "None";
    })(SubscriptionTypeEnum = FilespaceLineItem.SubscriptionTypeEnum || (FilespaceLineItem.SubscriptionTypeEnum = {}));
})(FilespaceLineItem = exports.FilespaceLineItem || (exports.FilespaceLineItem = {}));
exports.FilespaceLineItem = FilespaceLineItem;
var FilespaceS3Region = /** @class */ (function () {
    function FilespaceS3Region() {
    }
    FilespaceS3Region.getAttributeTypeMap = function () {
        return FilespaceS3Region.attributeTypeMap;
    };
    FilespaceS3Region.discriminator = undefined;
    FilespaceS3Region.attributeTypeMap = [
        {
            "name": "name",
            "baseName": "name",
            "type": "string"
        },
        {
            "name": "provider",
            "baseName": "provider",
            "type": "string"
        },
        {
            "name": "isLucidLinkOffering",
            "baseName": "isLucidLinkOffering",
            "type": "boolean"
        }
    ];
    return FilespaceS3Region;
}());
exports.FilespaceS3Region = FilespaceS3Region;
var FilespaceStats = /** @class */ (function () {
    function FilespaceStats() {
    }
    FilespaceStats.getAttributeTypeMap = function () {
        return FilespaceStats.attributeTypeMap;
    };
    FilespaceStats.discriminator = undefined;
    FilespaceStats.attributeTypeMap = [
        {
            "name": "usedStorage",
            "baseName": "usedStorage",
            "type": "number"
        },
        {
            "name": "deleteDataSize",
            "baseName": "deleteDataSize",
            "type": "number"
        },
        {
            "name": "filespaceSize",
            "baseName": "filespaceSize",
            "type": "number"
        },
        {
            "name": "getRequestCount",
            "baseName": "getRequestCount",
            "type": "number"
        },
        {
            "name": "getDataSize",
            "baseName": "getDataSize",
            "type": "number"
        },
        {
            "name": "putRequestCount",
            "baseName": "putRequestCount",
            "type": "number"
        },
        {
            "name": "putDataSize",
            "baseName": "putDataSize",
            "type": "number"
        },
        {
            "name": "listRequestCount",
            "baseName": "listRequestCount",
            "type": "number"
        },
        {
            "name": "deleteRequestCount",
            "baseName": "deleteRequestCount",
            "type": "number"
        },
        {
            "name": "connectedDevices",
            "baseName": "connectedDevices",
            "type": "number"
        }
    ];
    return FilespaceStats;
}());
exports.FilespaceStats = FilespaceStats;
var FilespaceStorage = /** @class */ (function () {
    function FilespaceStorage() {
    }
    FilespaceStorage.getAttributeTypeMap = function () {
        return FilespaceStorage.attributeTypeMap;
    };
    FilespaceStorage.discriminator = undefined;
    FilespaceStorage.attributeTypeMap = [
        {
            "name": "owner",
            "baseName": "owner",
            "type": "FilespaceStorage.OwnerEnum"
        },
        {
            "name": "_class",
            "baseName": "class",
            "type": "FilespaceStorage.ClassEnum"
        },
        {
            "name": "provider",
            "baseName": "provider",
            "type": "FilespaceStorage.ProviderEnum"
        },
        {
            "name": "region",
            "baseName": "region",
            "type": "string"
        },
        {
            "name": "endpoint",
            "baseName": "endpoint",
            "type": "string"
        },
        {
            "name": "bucket",
            "baseName": "bucket",
            "type": "string"
        },
        {
            "name": "blockSize",
            "baseName": "blockSize",
            "type": "number"
        },
        {
            "name": "username",
            "baseName": "username",
            "type": "string"
        },
        {
            "name": "accessKeyId",
            "baseName": "accessKeyId",
            "type": "string"
        },
        {
            "name": "secretAccessKey",
            "baseName": "secretAccessKey",
            "type": "string"
        }
    ];
    return FilespaceStorage;
}());
exports.FilespaceStorage = FilespaceStorage;
(function (FilespaceStorage) {
    var OwnerEnum;
    (function (OwnerEnum) {
        OwnerEnum[OwnerEnum["Customer"] = 'customer'] = "Customer";
        OwnerEnum[OwnerEnum["Lucidlink"] = 'lucidlink'] = "Lucidlink";
    })(OwnerEnum = FilespaceStorage.OwnerEnum || (FilespaceStorage.OwnerEnum = {}));
    var ClassEnum;
    (function (ClassEnum) {
        ClassEnum[ClassEnum["Standard"] = 'standard'] = "Standard";
        ClassEnum[ClassEnum["IntelligentTiering"] = 'intelligent_tiering'] = "IntelligentTiering";
    })(ClassEnum = FilespaceStorage.ClassEnum || (FilespaceStorage.ClassEnum = {}));
    var ProviderEnum;
    (function (ProviderEnum) {
        ProviderEnum[ProviderEnum["Azure"] = 'Azure'] = "Azure";
        ProviderEnum[ProviderEnum["AWS"] = 'AWS'] = "AWS";
        ProviderEnum[ProviderEnum["AWSGovCloud"] = 'AWSGovCloud'] = "AWSGovCloud";
        ProviderEnum[ProviderEnum["Alibaba"] = 'Alibaba'] = "Alibaba";
        ProviderEnum[ProviderEnum["GCP"] = 'GCP'] = "GCP";
        ProviderEnum[ProviderEnum["Zadara"] = 'Zadara'] = "Zadara";
        ProviderEnum[ProviderEnum["Cloudian"] = 'Cloudian'] = "Cloudian";
        ProviderEnum[ProviderEnum["DigitalOcean"] = 'DigitalOcean'] = "DigitalOcean";
        ProviderEnum[ProviderEnum["Wasabi"] = 'Wasabi'] = "Wasabi";
        ProviderEnum[ProviderEnum["Scality"] = 'Scality'] = "Scality";
        ProviderEnum[ProviderEnum["Telefonica"] = 'Telefonica'] = "Telefonica";
        ProviderEnum[ProviderEnum["Exoscale"] = 'Exoscale'] = "Exoscale";
        ProviderEnum[ProviderEnum["Nutanix"] = 'Nutanix'] = "Nutanix";
        ProviderEnum[ProviderEnum["Pure"] = 'Pure'] = "Pure";
        ProviderEnum[ProviderEnum["Dell"] = 'Dell'] = "Dell";
        ProviderEnum[ProviderEnum["IBM"] = 'IBM'] = "IBM";
        ProviderEnum[ProviderEnum["Backblaze"] = 'Backblaze'] = "Backblaze";
        ProviderEnum[ProviderEnum["Other"] = 'Other'] = "Other";
    })(ProviderEnum = FilespaceStorage.ProviderEnum || (FilespaceStorage.ProviderEnum = {}));
})(FilespaceStorage = exports.FilespaceStorage || (exports.FilespaceStorage = {}));
exports.FilespaceStorage = FilespaceStorage;
var FilespaceUsage = /** @class */ (function () {
    function FilespaceUsage() {
    }
    FilespaceUsage.getAttributeTypeMap = function () {
        return FilespaceUsage.attributeTypeMap;
    };
    FilespaceUsage.discriminator = undefined;
    FilespaceUsage.attributeTypeMap = [
        {
            "name": "usage",
            "baseName": "usage",
            "type": "number"
        },
        {
            "name": "dimension",
            "baseName": "dimension",
            "type": "FilespaceUsage.DimensionEnum"
        }
    ];
    return FilespaceUsage;
}());
exports.FilespaceUsage = FilespaceUsage;
(function (FilespaceUsage) {
    var DimensionEnum;
    (function (DimensionEnum) {
        DimensionEnum[DimensionEnum["Capacity"] = 'Capacity'] = "Capacity";
        DimensionEnum[DimensionEnum["ConnectedDevices"] = 'ConnectedDevices'] = "ConnectedDevices";
        DimensionEnum[DimensionEnum["FilespaceDays"] = 'FilespaceDays'] = "FilespaceDays";
        DimensionEnum[DimensionEnum["Storage"] = 'Storage'] = "Storage";
        DimensionEnum[DimensionEnum["ManagedCapacity"] = 'ManagedCapacity'] = "ManagedCapacity";
        DimensionEnum[DimensionEnum["Egress"] = 'Egress'] = "Egress";
        DimensionEnum[DimensionEnum["FilespaceUsers"] = 'FilespaceUsers'] = "FilespaceUsers";
    })(DimensionEnum = FilespaceUsage.DimensionEnum || (FilespaceUsage.DimensionEnum = {}));
})(FilespaceUsage = exports.FilespaceUsage || (exports.FilespaceUsage = {}));
exports.FilespaceUsage = FilespaceUsage;
var Invoice = /** @class */ (function () {
    function Invoice() {
    }
    Invoice.getAttributeTypeMap = function () {
        return Invoice.attributeTypeMap;
    };
    Invoice.discriminator = undefined;
    Invoice.attributeTypeMap = [
        {
            "name": "id",
            "baseName": "id",
            "type": "string"
        },
        {
            "name": "date",
            "baseName": "date",
            "type": "number"
        },
        {
            "name": "lineDescriptions",
            "baseName": "lineDescriptions",
            "type": "Array<string>"
        },
        {
            "name": "amountDue",
            "baseName": "amountDue",
            "type": "number"
        },
        {
            "name": "currency",
            "baseName": "currency",
            "type": "string"
        },
        {
            "name": "periodStart",
            "baseName": "periodStart",
            "type": "number"
        },
        {
            "name": "periodEnd",
            "baseName": "periodEnd",
            "type": "number"
        },
        {
            "name": "paymentStatus",
            "baseName": "paymentStatus",
            "type": "Invoice.PaymentStatusEnum"
        },
        {
            "name": "pdfUrl",
            "baseName": "pdfUrl",
            "type": "string"
        },
        {
            "name": "filespaceBreakdown",
            "baseName": "filespaceBreakdown",
            "type": "Array<FilespaceLineItem>"
        }
    ];
    return Invoice;
}());
exports.Invoice = Invoice;
(function (Invoice) {
    var PaymentStatusEnum;
    (function (PaymentStatusEnum) {
        PaymentStatusEnum[PaymentStatusEnum["NotPaid"] = 'not_paid'] = "NotPaid";
        PaymentStatusEnum[PaymentStatusEnum["PastDue"] = 'past_due'] = "PastDue";
        PaymentStatusEnum[PaymentStatusEnum["Paid"] = 'paid'] = "Paid";
        PaymentStatusEnum[PaymentStatusEnum["Voided"] = 'voided'] = "Voided";
    })(PaymentStatusEnum = Invoice.PaymentStatusEnum || (Invoice.PaymentStatusEnum = {}));
})(Invoice = exports.Invoice || (exports.Invoice = {}));
exports.Invoice = Invoice;
var InvoiceID = /** @class */ (function () {
    function InvoiceID() {
    }
    InvoiceID.getAttributeTypeMap = function () {
        return InvoiceID.attributeTypeMap;
    };
    InvoiceID.discriminator = undefined;
    InvoiceID.attributeTypeMap = [
        {
            "name": "id",
            "baseName": "id",
            "type": "string"
        }
    ];
    return InvoiceID;
}());
exports.InvoiceID = InvoiceID;
var NotFound = /** @class */ (function () {
    function NotFound() {
    }
    NotFound.getAttributeTypeMap = function () {
        return NotFound.attributeTypeMap;
    };
    NotFound.discriminator = undefined;
    NotFound.attributeTypeMap = [
        {
            "name": "status",
            "baseName": "status",
            "type": "number"
        },
        {
            "name": "message",
            "baseName": "message",
            "type": "string"
        }
    ];
    return NotFound;
}());
exports.NotFound = NotFound;
var PaymentDetails = /** @class */ (function () {
    function PaymentDetails() {
    }
    PaymentDetails.getAttributeTypeMap = function () {
        return PaymentDetails.attributeTypeMap;
    };
    PaymentDetails.discriminator = undefined;
    PaymentDetails.attributeTypeMap = [
        {
            "name": "description",
            "baseName": "description",
            "type": "string"
        },
        {
            "name": "paymentSourceToken",
            "baseName": "paymentSourceToken",
            "type": "string"
        },
        {
            "name": "name",
            "baseName": "name",
            "type": "string"
        },
        {
            "name": "card",
            "baseName": "card",
            "type": "Card"
        },
        {
            "name": "billingAddress",
            "baseName": "billingAddress",
            "type": "BillingAddress"
        },
        {
            "name": "paymentMethod",
            "baseName": "paymentMethod",
            "type": "PaymentDetails.PaymentMethodEnum"
        },
        {
            "name": "taxStatus",
            "baseName": "taxStatus",
            "type": "string"
        },
        {
            "name": "taxCode",
            "baseName": "taxCode",
            "type": "string"
        }
    ];
    return PaymentDetails;
}());
exports.PaymentDetails = PaymentDetails;
(function (PaymentDetails) {
    var PaymentMethodEnum;
    (function (PaymentMethodEnum) {
        PaymentMethodEnum[PaymentMethodEnum["CreditCard"] = 'credit_card'] = "CreditCard";
        PaymentMethodEnum[PaymentMethodEnum["WireOrCheck"] = 'wire_or_check'] = "WireOrCheck";
        PaymentMethodEnum[PaymentMethodEnum["Invalid"] = 'invalid'] = "Invalid";
    })(PaymentMethodEnum = PaymentDetails.PaymentMethodEnum || (PaymentDetails.PaymentMethodEnum = {}));
})(PaymentDetails = exports.PaymentDetails || (exports.PaymentDetails = {}));
exports.PaymentDetails = PaymentDetails;
var PaymentRequired = /** @class */ (function () {
    function PaymentRequired() {
    }
    PaymentRequired.getAttributeTypeMap = function () {
        return PaymentRequired.attributeTypeMap;
    };
    PaymentRequired.discriminator = undefined;
    PaymentRequired.attributeTypeMap = [
        {
            "name": "status",
            "baseName": "status",
            "type": "number"
        },
        {
            "name": "message",
            "baseName": "message",
            "type": "string"
        }
    ];
    return PaymentRequired;
}());
exports.PaymentRequired = PaymentRequired;
var Plan = /** @class */ (function () {
    function Plan() {
    }
    Plan.getAttributeTypeMap = function () {
        return Plan.attributeTypeMap;
    };
    Plan.discriminator = undefined;
    Plan.attributeTypeMap = [
        {
            "name": "dimension",
            "baseName": "dimension",
            "type": "Plan.DimensionEnum"
        },
        {
            "name": "externalId",
            "baseName": "externalId",
            "type": "string"
        },
        {
            "name": "tiers",
            "baseName": "tiers",
            "type": "Array<PlanTier>"
        }
    ];
    return Plan;
}());
exports.Plan = Plan;
(function (Plan) {
    var DimensionEnum;
    (function (DimensionEnum) {
        DimensionEnum[DimensionEnum["Capacity"] = 'Capacity'] = "Capacity";
        DimensionEnum[DimensionEnum["ConnectedDevices"] = 'ConnectedDevices'] = "ConnectedDevices";
        DimensionEnum[DimensionEnum["FilespaceDays"] = 'FilespaceDays'] = "FilespaceDays";
        DimensionEnum[DimensionEnum["Storage"] = 'Storage'] = "Storage";
        DimensionEnum[DimensionEnum["ManagedCapacity"] = 'ManagedCapacity'] = "ManagedCapacity";
        DimensionEnum[DimensionEnum["Egress"] = 'Egress'] = "Egress";
        DimensionEnum[DimensionEnum["FilespaceUsers"] = 'FilespaceUsers'] = "FilespaceUsers";
    })(DimensionEnum = Plan.DimensionEnum || (Plan.DimensionEnum = {}));
})(Plan = exports.Plan || (exports.Plan = {}));
exports.Plan = Plan;
var PlanPackageCriterion = /** @class */ (function () {
    function PlanPackageCriterion() {
    }
    PlanPackageCriterion.getAttributeTypeMap = function () {
        return PlanPackageCriterion.attributeTypeMap;
    };
    PlanPackageCriterion.discriminator = undefined;
    PlanPackageCriterion.attributeTypeMap = [
        {
            "name": "storageOwner",
            "baseName": "storageOwner",
            "type": "PlanPackageCriterion.StorageOwnerEnum"
        },
        {
            "name": "storageProvider",
            "baseName": "storageProvider",
            "type": "string"
        },
        {
            "name": "subscriptionType",
            "baseName": "subscriptionType",
            "type": "PlanPackageCriterion.SubscriptionTypeEnum"
        }
    ];
    return PlanPackageCriterion;
}());
exports.PlanPackageCriterion = PlanPackageCriterion;
(function (PlanPackageCriterion) {
    var StorageOwnerEnum;
    (function (StorageOwnerEnum) {
        StorageOwnerEnum[StorageOwnerEnum["Lucidlink"] = 'lucidlink'] = "Lucidlink";
        StorageOwnerEnum[StorageOwnerEnum["Customer"] = 'customer'] = "Customer";
        StorageOwnerEnum[StorageOwnerEnum["Any"] = 'any'] = "Any";
    })(StorageOwnerEnum = PlanPackageCriterion.StorageOwnerEnum || (PlanPackageCriterion.StorageOwnerEnum = {}));
    var SubscriptionTypeEnum;
    (function (SubscriptionTypeEnum) {
        SubscriptionTypeEnum[SubscriptionTypeEnum["Basic"] = 'basic'] = "Basic";
        SubscriptionTypeEnum[SubscriptionTypeEnum["Teams"] = 'teams'] = "Teams";
        SubscriptionTypeEnum[SubscriptionTypeEnum["Advanced"] = 'advanced'] = "Advanced";
        SubscriptionTypeEnum[SubscriptionTypeEnum["Enterprise"] = 'enterprise'] = "Enterprise";
        SubscriptionTypeEnum[SubscriptionTypeEnum["Custom"] = 'custom'] = "Custom";
        SubscriptionTypeEnum[SubscriptionTypeEnum["None"] = 'none'] = "None";
        SubscriptionTypeEnum[SubscriptionTypeEnum["Any"] = 'any'] = "Any";
    })(SubscriptionTypeEnum = PlanPackageCriterion.SubscriptionTypeEnum || (PlanPackageCriterion.SubscriptionTypeEnum = {}));
})(PlanPackageCriterion = exports.PlanPackageCriterion || (exports.PlanPackageCriterion = {}));
exports.PlanPackageCriterion = PlanPackageCriterion;
var PlanPackageNoId = /** @class */ (function () {
    function PlanPackageNoId() {
    }
    PlanPackageNoId.getAttributeTypeMap = function () {
        return PlanPackageNoId.attributeTypeMap;
    };
    PlanPackageNoId.discriminator = undefined;
    PlanPackageNoId.attributeTypeMap = [
        {
            "name": "includeCriteria",
            "baseName": "includeCriteria",
            "type": "Array<PlanPackageCriterion>"
        },
        {
            "name": "excludeCriteria",
            "baseName": "excludeCriteria",
            "type": "Array<PlanPackageCriterion>"
        },
        {
            "name": "plans",
            "baseName": "plans",
            "type": "Array<Plan>"
        },
        {
            "name": "dimensionLimits",
            "baseName": "dimensionLimits",
            "type": "Array<DimensionLimit>"
        }
    ];
    return PlanPackageNoId;
}());
exports.PlanPackageNoId = PlanPackageNoId;
var PlanPackageUpdate = /** @class */ (function () {
    function PlanPackageUpdate() {
    }
    PlanPackageUpdate.getAttributeTypeMap = function () {
        return PlanPackageUpdate.attributeTypeMap;
    };
    PlanPackageUpdate.discriminator = undefined;
    PlanPackageUpdate.attributeTypeMap = [
        {
            "name": "id",
            "baseName": "id",
            "type": "string"
        },
        {
            "name": "includeCriteriaUpdate",
            "baseName": "includeCriteriaUpdate",
            "type": "Array<PlanPackageCriterion>"
        },
        {
            "name": "excludeCriteriaUpdate",
            "baseName": "excludeCriteriaUpdate",
            "type": "Array<PlanPackageCriterion>"
        },
        {
            "name": "planUpdate",
            "baseName": "planUpdate",
            "type": "PlanUpdate"
        },
        {
            "name": "action",
            "baseName": "action",
            "type": "PlanPackageUpdate.ActionEnum"
        }
    ];
    return PlanPackageUpdate;
}());
exports.PlanPackageUpdate = PlanPackageUpdate;
(function (PlanPackageUpdate) {
    var ActionEnum;
    (function (ActionEnum) {
        ActionEnum[ActionEnum["Create"] = 'create'] = "Create";
        ActionEnum[ActionEnum["Delete"] = 'delete'] = "Delete";
        ActionEnum[ActionEnum["Update"] = 'update'] = "Update";
    })(ActionEnum = PlanPackageUpdate.ActionEnum || (PlanPackageUpdate.ActionEnum = {}));
})(PlanPackageUpdate = exports.PlanPackageUpdate || (exports.PlanPackageUpdate = {}));
exports.PlanPackageUpdate = PlanPackageUpdate;
var PlanTier = /** @class */ (function () {
    function PlanTier() {
    }
    PlanTier.getAttributeTypeMap = function () {
        return PlanTier.attributeTypeMap;
    };
    PlanTier.discriminator = undefined;
    PlanTier.attributeTypeMap = [
        {
            "name": "from",
            "baseName": "from",
            "type": "number"
        },
        {
            "name": "upTo",
            "baseName": "upTo",
            "type": "number"
        },
        {
            "name": "pricePerUnit",
            "baseName": "pricePerUnit",
            "type": "string"
        },
        {
            "name": "flatPrice",
            "baseName": "flatPrice",
            "type": "string"
        }
    ];
    return PlanTier;
}());
exports.PlanTier = PlanTier;
var PlanUpdate = /** @class */ (function () {
    function PlanUpdate() {
    }
    PlanUpdate.getAttributeTypeMap = function () {
        return PlanUpdate.attributeTypeMap;
    };
    PlanUpdate.discriminator = undefined;
    PlanUpdate.attributeTypeMap = [
        {
            "name": "dimension",
            "baseName": "dimension",
            "type": "PlanUpdate.DimensionEnum"
        },
        {
            "name": "tieredPlan",
            "baseName": "tieredPlan",
            "type": "Array<PlanTier>"
        },
        {
            "name": "price",
            "baseName": "price",
            "type": "string"
        },
        {
            "name": "externalId",
            "baseName": "externalId",
            "type": "string"
        },
        {
            "name": "action",
            "baseName": "action",
            "type": "PlanUpdate.ActionEnum"
        }
    ];
    return PlanUpdate;
}());
exports.PlanUpdate = PlanUpdate;
(function (PlanUpdate) {
    var DimensionEnum;
    (function (DimensionEnum) {
        DimensionEnum[DimensionEnum["Capacity"] = 'Capacity'] = "Capacity";
        DimensionEnum[DimensionEnum["ConnectedDevices"] = 'ConnectedDevices'] = "ConnectedDevices";
        DimensionEnum[DimensionEnum["FilespaceDays"] = 'FilespaceDays'] = "FilespaceDays";
        DimensionEnum[DimensionEnum["Storage"] = 'Storage'] = "Storage";
        DimensionEnum[DimensionEnum["ManagedCapacity"] = 'ManagedCapacity'] = "ManagedCapacity";
        DimensionEnum[DimensionEnum["Egress"] = 'Egress'] = "Egress";
        DimensionEnum[DimensionEnum["FilespaceUsers"] = 'FilespaceUsers'] = "FilespaceUsers";
    })(DimensionEnum = PlanUpdate.DimensionEnum || (PlanUpdate.DimensionEnum = {}));
    var ActionEnum;
    (function (ActionEnum) {
        ActionEnum[ActionEnum["Create"] = 'create'] = "Create";
        ActionEnum[ActionEnum["Delete"] = 'delete'] = "Delete";
        ActionEnum[ActionEnum["Update"] = 'update'] = "Update";
    })(ActionEnum = PlanUpdate.ActionEnum || (PlanUpdate.ActionEnum = {}));
})(PlanUpdate = exports.PlanUpdate || (exports.PlanUpdate = {}));
exports.PlanUpdate = PlanUpdate;
var RemoteRekeyPayload = /** @class */ (function () {
    function RemoteRekeyPayload() {
    }
    RemoteRekeyPayload.getAttributeTypeMap = function () {
        return RemoteRekeyPayload.attributeTypeMap;
    };
    RemoteRekeyPayload.discriminator = undefined;
    RemoteRekeyPayload.attributeTypeMap = [
        {
            "name": "revokedKey",
            "baseName": "revokedKey",
            "type": "string"
        },
        {
            "name": "activeKey",
            "baseName": "activeKey",
            "type": "string"
        }
    ];
    return RemoteRekeyPayload;
}());
exports.RemoteRekeyPayload = RemoteRekeyPayload;
var UnprocessableEntity = /** @class */ (function () {
    function UnprocessableEntity() {
    }
    UnprocessableEntity.getAttributeTypeMap = function () {
        return UnprocessableEntity.attributeTypeMap;
    };
    UnprocessableEntity.discriminator = undefined;
    UnprocessableEntity.attributeTypeMap = [
        {
            "name": "status",
            "baseName": "status",
            "type": "number"
        },
        {
            "name": "message",
            "baseName": "message",
            "type": "string"
        }
    ];
    return UnprocessableEntity;
}());
exports.UnprocessableEntity = UnprocessableEntity;
var UserEmail = /** @class */ (function () {
    function UserEmail() {
    }
    UserEmail.getAttributeTypeMap = function () {
        return UserEmail.attributeTypeMap;
    };
    UserEmail.discriminator = undefined;
    UserEmail.attributeTypeMap = [
        {
            "name": "email",
            "baseName": "email",
            "type": "string"
        }
    ];
    return UserEmail;
}());
exports.UserEmail = UserEmail;
var UtmData = /** @class */ (function () {
    function UtmData() {
    }
    UtmData.getAttributeTypeMap = function () {
        return UtmData.attributeTypeMap;
    };
    UtmData.discriminator = undefined;
    UtmData.attributeTypeMap = [
        {
            "name": "utmSource",
            "baseName": "utm_source",
            "type": "string"
        },
        {
            "name": "utmMedium",
            "baseName": "utm_medium",
            "type": "string"
        },
        {
            "name": "utmCampaign",
            "baseName": "utm_campaign",
            "type": "string"
        },
        {
            "name": "utmId",
            "baseName": "utm_id",
            "type": "string"
        },
        {
            "name": "utmTerm",
            "baseName": "utm_term",
            "type": "string"
        }
    ];
    return UtmData;
}());
exports.UtmData = UtmData;
var VerificationCode = /** @class */ (function () {
    function VerificationCode() {
    }
    VerificationCode.getAttributeTypeMap = function () {
        return VerificationCode.attributeTypeMap;
    };
    VerificationCode.discriminator = undefined;
    VerificationCode.attributeTypeMap = [
        {
            "name": "verificationType",
            "baseName": "verificationType",
            "type": "VerificationCode.VerificationTypeEnum"
        },
        {
            "name": "code",
            "baseName": "code",
            "type": "string"
        }
    ];
    return VerificationCode;
}());
exports.VerificationCode = VerificationCode;
(function (VerificationCode) {
    var VerificationTypeEnum;
    (function (VerificationTypeEnum) {
        VerificationTypeEnum[VerificationTypeEnum["Email"] = 'email'] = "Email";
    })(VerificationTypeEnum = VerificationCode.VerificationTypeEnum || (VerificationCode.VerificationTypeEnum = {}));
})(VerificationCode = exports.VerificationCode || (exports.VerificationCode = {}));
exports.VerificationCode = VerificationCode;
var VerificationRequired = /** @class */ (function () {
    function VerificationRequired() {
    }
    VerificationRequired.getAttributeTypeMap = function () {
        return VerificationRequired.attributeTypeMap;
    };
    VerificationRequired.discriminator = undefined;
    VerificationRequired.attributeTypeMap = [
        {
            "name": "status",
            "baseName": "status",
            "type": "number"
        },
        {
            "name": "verificationType",
            "baseName": "verificationType",
            "type": "VerificationRequired.VerificationTypeEnum"
        },
        {
            "name": "message",
            "baseName": "message",
            "type": "string"
        }
    ];
    return VerificationRequired;
}());
exports.VerificationRequired = VerificationRequired;
(function (VerificationRequired) {
    var VerificationTypeEnum;
    (function (VerificationTypeEnum) {
        VerificationTypeEnum[VerificationTypeEnum["EmailVerificationCode"] = 'emailVerificationCode'] = "EmailVerificationCode";
    })(VerificationTypeEnum = VerificationRequired.VerificationTypeEnum || (VerificationRequired.VerificationTypeEnum = {}));
})(VerificationRequired = exports.VerificationRequired || (exports.VerificationRequired = {}));
exports.VerificationRequired = VerificationRequired;
var AdminUserSearchResultExtended = /** @class */ (function () {
    function AdminUserSearchResultExtended() {
    }
    AdminUserSearchResultExtended.getAttributeTypeMap = function () {
        return AdminUserSearchResultExtended.attributeTypeMap;
    };
    AdminUserSearchResultExtended.discriminator = undefined;
    AdminUserSearchResultExtended.attributeTypeMap = [
        {
            "name": "id",
            "baseName": "id",
            "type": "string"
        },
        {
            "name": "isSuspended",
            "baseName": "isSuspended",
            "type": "boolean"
        },
        {
            "name": "identityProviders",
            "baseName": "identityProviders",
            "type": "string"
        },
        {
            "name": "email",
            "baseName": "email",
            "type": "string"
        },
        {
            "name": "created",
            "baseName": "created",
            "type": "number"
        },
        {
            "name": "isAccountTrial",
            "baseName": "isAccountTrial",
            "type": "boolean"
        },
        {
            "name": "hasApiKey",
            "baseName": "hasApiKey",
            "type": "boolean"
        },
        {
            "name": "trialEndDate",
            "baseName": "trialEndDate",
            "type": "number"
        },
        {
            "name": "phoneNumber",
            "baseName": "phoneNumber",
            "type": "string"
        },
        {
            "name": "companyName",
            "baseName": "companyName",
            "type": "string"
        },
        {
            "name": "stripeLink",
            "baseName": "stripeLink",
            "type": "string"
        },
        {
            "name": "givenName",
            "baseName": "givenName",
            "type": "string"
        },
        {
            "name": "familyName",
            "baseName": "familyName",
            "type": "string"
        },
        {
            "name": "paymentMethods",
            "baseName": "paymentMethods",
            "type": "Array<AdminUserSearchResultExtended.PaymentMethodsEnum>"
        }
    ];
    return AdminUserSearchResultExtended;
}());
exports.AdminUserSearchResultExtended = AdminUserSearchResultExtended;
(function (AdminUserSearchResultExtended) {
    var PaymentMethodsEnum;
    (function (PaymentMethodsEnum) {
        PaymentMethodsEnum[PaymentMethodsEnum["CreditCard"] = 'credit_card'] = "CreditCard";
        PaymentMethodsEnum[PaymentMethodsEnum["WireOrCheck"] = 'wire_or_check'] = "WireOrCheck";
        PaymentMethodsEnum[PaymentMethodsEnum["Invalid"] = 'invalid'] = "Invalid";
    })(PaymentMethodsEnum = AdminUserSearchResultExtended.PaymentMethodsEnum || (AdminUserSearchResultExtended.PaymentMethodsEnum = {}));
})(AdminUserSearchResultExtended = exports.AdminUserSearchResultExtended || (exports.AdminUserSearchResultExtended = {}));
exports.AdminUserSearchResultExtended = AdminUserSearchResultExtended;
var FilespaceExtended = /** @class */ (function () {
    function FilespaceExtended() {
    }
    FilespaceExtended.getAttributeTypeMap = function () {
        return FilespaceExtended.attributeTypeMap;
    };
    FilespaceExtended.discriminator = undefined;
    FilespaceExtended.attributeTypeMap = [
        {
            "name": "id",
            "baseName": "id",
            "type": "string"
        },
        {
            "name": "domain",
            "baseName": "domain",
            "type": "string"
        },
        {
            "name": "isSuspended",
            "baseName": "isSuspended",
            "type": "boolean"
        },
        {
            "name": "name",
            "baseName": "name",
            "type": "string"
        },
        {
            "name": "subscriptionType",
            "baseName": "subscriptionType",
            "type": "FilespaceExtended.SubscriptionTypeEnum"
        },
        {
            "name": "type",
            "baseName": "type",
            "type": "FilespaceExtended.TypeEnum"
        },
        {
            "name": "status",
            "baseName": "status",
            "type": "FilespaceExtended.StatusEnum"
        },
        {
            "name": "renameStatus",
            "baseName": "renameStatus",
            "type": "FilespaceExtended.RenameStatusEnum"
        },
        {
            "name": "suspensionStatus",
            "baseName": "suspensionStatus",
            "type": "FilespaceExtended.SuspensionStatusEnum"
        },
        {
            "name": "version",
            "baseName": "version",
            "type": "number"
        },
        {
            "name": "storage",
            "baseName": "storage",
            "type": "FilespaceStorage"
        },
        {
            "name": "stats",
            "baseName": "stats",
            "type": "any"
        },
        {
            "name": "usersCount",
            "baseName": "usersCount",
            "type": "number"
        },
        {
            "name": "fsId",
            "baseName": "fsId",
            "type": "string"
        },
        {
            "name": "isDeleted",
            "baseName": "isDeleted",
            "type": "boolean"
        },
        {
            "name": "deletionDate",
            "baseName": "deletionDate",
            "type": "number"
        },
        {
            "name": "hubRegion",
            "baseName": "hubRegion",
            "type": "string"
        },
        {
            "name": "hubProvider",
            "baseName": "hubProvider",
            "type": "string"
        },
        {
            "name": "backupRegion",
            "baseName": "backupRegion",
            "type": "string"
        },
        {
            "name": "hosts",
            "baseName": "hosts",
            "type": "Array<string>"
        },
        {
            "name": "kibanaLink",
            "baseName": "kibanaLink",
            "type": "string"
        },
        {
            "name": "grafanaLink",
            "baseName": "grafanaLink",
            "type": "string"
        },
        {
            "name": "hubsCheck",
            "baseName": "hubsCheck",
            "type": "string"
        },
        {
            "name": "createdTime",
            "baseName": "createdTime",
            "type": "number"
        }
    ];
    return FilespaceExtended;
}());
exports.FilespaceExtended = FilespaceExtended;
(function (FilespaceExtended) {
    var SubscriptionTypeEnum;
    (function (SubscriptionTypeEnum) {
        SubscriptionTypeEnum[SubscriptionTypeEnum["Basic"] = 'basic'] = "Basic";
        SubscriptionTypeEnum[SubscriptionTypeEnum["Teams"] = 'teams'] = "Teams";
        SubscriptionTypeEnum[SubscriptionTypeEnum["Advanced"] = 'advanced'] = "Advanced";
        SubscriptionTypeEnum[SubscriptionTypeEnum["Enterprise"] = 'enterprise'] = "Enterprise";
        SubscriptionTypeEnum[SubscriptionTypeEnum["Custom"] = 'custom'] = "Custom";
        SubscriptionTypeEnum[SubscriptionTypeEnum["None"] = 'none'] = "None";
    })(SubscriptionTypeEnum = FilespaceExtended.SubscriptionTypeEnum || (FilespaceExtended.SubscriptionTypeEnum = {}));
    var TypeEnum;
    (function (TypeEnum) {
        TypeEnum[TypeEnum["Sandbox"] = 'sandbox'] = "Sandbox";
        TypeEnum[TypeEnum["Unlimited"] = 'unlimited'] = "Unlimited";
        TypeEnum[TypeEnum["V4beta"] = 'v4beta'] = "V4beta";
    })(TypeEnum = FilespaceExtended.TypeEnum || (FilespaceExtended.TypeEnum = {}));
    var StatusEnum;
    (function (StatusEnum) {
        StatusEnum[StatusEnum["Provisioning"] = 'provisioning'] = "Provisioning";
        StatusEnum[StatusEnum["Provisioned"] = 'provisioned'] = "Provisioned";
        StatusEnum[StatusEnum["Initialized"] = 'initialized'] = "Initialized";
        StatusEnum[StatusEnum["Errored"] = 'errored'] = "Errored";
    })(StatusEnum = FilespaceExtended.StatusEnum || (FilespaceExtended.StatusEnum = {}));
    var RenameStatusEnum;
    (function (RenameStatusEnum) {
        RenameStatusEnum[RenameStatusEnum["Success"] = 'success'] = "Success";
        RenameStatusEnum[RenameStatusEnum["Errored"] = 'errored'] = "Errored";
        RenameStatusEnum[RenameStatusEnum["Inprogress"] = 'inprogress'] = "Inprogress";
    })(RenameStatusEnum = FilespaceExtended.RenameStatusEnum || (FilespaceExtended.RenameStatusEnum = {}));
    var SuspensionStatusEnum;
    (function (SuspensionStatusEnum) {
        SuspensionStatusEnum[SuspensionStatusEnum["Suspending"] = 'suspending'] = "Suspending";
        SuspensionStatusEnum[SuspensionStatusEnum["Suspended"] = 'suspended'] = "Suspended";
        SuspensionStatusEnum[SuspensionStatusEnum["SuspensionFailed"] = 'suspension_failed'] = "SuspensionFailed";
        SuspensionStatusEnum[SuspensionStatusEnum["Unsuspending"] = 'unsuspending'] = "Unsuspending";
        SuspensionStatusEnum[SuspensionStatusEnum["UnsuspensionFailed"] = 'unsuspension_failed'] = "UnsuspensionFailed";
        SuspensionStatusEnum[SuspensionStatusEnum["NotSuspended"] = 'not_suspended'] = "NotSuspended";
        SuspensionStatusEnum[SuspensionStatusEnum["Errored"] = 'errored'] = "Errored";
    })(SuspensionStatusEnum = FilespaceExtended.SuspensionStatusEnum || (FilespaceExtended.SuspensionStatusEnum = {}));
})(FilespaceExtended = exports.FilespaceExtended || (exports.FilespaceExtended = {}));
exports.FilespaceExtended = FilespaceExtended;
var FilespaceLineItemWithForecast = /** @class */ (function () {
    function FilespaceLineItemWithForecast() {
    }
    FilespaceLineItemWithForecast.getAttributeTypeMap = function () {
        return FilespaceLineItemWithForecast.attributeTypeMap;
    };
    FilespaceLineItemWithForecast.discriminator = undefined;
    FilespaceLineItemWithForecast.attributeTypeMap = [
        {
            "name": "filespace",
            "baseName": "filespace",
            "type": "string"
        },
        {
            "name": "amountDue",
            "baseName": "amountDue",
            "type": "number"
        },
        {
            "name": "isDeleted",
            "baseName": "isDeleted",
            "type": "boolean"
        },
        {
            "name": "name",
            "baseName": "name",
            "type": "string"
        },
        {
            "name": "storageProvider",
            "baseName": "storageProvider",
            "type": "string"
        },
        {
            "name": "storageOwner",
            "baseName": "storageOwner",
            "type": "FilespaceLineItemWithForecast.StorageOwnerEnum"
        },
        {
            "name": "subscriptionType",
            "baseName": "subscriptionType",
            "type": "FilespaceLineItemWithForecast.SubscriptionTypeEnum"
        },
        {
            "name": "usageByDimension",
            "baseName": "usageByDimension",
            "type": "Array<FilespaceUsage>"
        },
        {
            "name": "amountDueForecast",
            "baseName": "amountDueForecast",
            "type": "number"
        }
    ];
    return FilespaceLineItemWithForecast;
}());
exports.FilespaceLineItemWithForecast = FilespaceLineItemWithForecast;
(function (FilespaceLineItemWithForecast) {
    var StorageOwnerEnum;
    (function (StorageOwnerEnum) {
        StorageOwnerEnum[StorageOwnerEnum["Lucidlink"] = 'lucidlink'] = "Lucidlink";
        StorageOwnerEnum[StorageOwnerEnum["Customer"] = 'customer'] = "Customer";
    })(StorageOwnerEnum = FilespaceLineItemWithForecast.StorageOwnerEnum || (FilespaceLineItemWithForecast.StorageOwnerEnum = {}));
    var SubscriptionTypeEnum;
    (function (SubscriptionTypeEnum) {
        SubscriptionTypeEnum[SubscriptionTypeEnum["Basic"] = 'basic'] = "Basic";
        SubscriptionTypeEnum[SubscriptionTypeEnum["Teams"] = 'teams'] = "Teams";
        SubscriptionTypeEnum[SubscriptionTypeEnum["Advanced"] = 'advanced'] = "Advanced";
        SubscriptionTypeEnum[SubscriptionTypeEnum["Enterprise"] = 'enterprise'] = "Enterprise";
        SubscriptionTypeEnum[SubscriptionTypeEnum["Custom"] = 'custom'] = "Custom";
        SubscriptionTypeEnum[SubscriptionTypeEnum["None"] = 'none'] = "None";
    })(SubscriptionTypeEnum = FilespaceLineItemWithForecast.SubscriptionTypeEnum || (FilespaceLineItemWithForecast.SubscriptionTypeEnum = {}));
})(FilespaceLineItemWithForecast = exports.FilespaceLineItemWithForecast || (exports.FilespaceLineItemWithForecast = {}));
exports.FilespaceLineItemWithForecast = FilespaceLineItemWithForecast;
var PlanPackage = /** @class */ (function () {
    function PlanPackage() {
    }
    PlanPackage.getAttributeTypeMap = function () {
        return PlanPackage.attributeTypeMap;
    };
    PlanPackage.discriminator = undefined;
    PlanPackage.attributeTypeMap = [
        {
            "name": "includeCriteria",
            "baseName": "includeCriteria",
            "type": "Array<PlanPackageCriterion>"
        },
        {
            "name": "excludeCriteria",
            "baseName": "excludeCriteria",
            "type": "Array<PlanPackageCriterion>"
        },
        {
            "name": "plans",
            "baseName": "plans",
            "type": "Array<Plan>"
        },
        {
            "name": "dimensionLimits",
            "baseName": "dimensionLimits",
            "type": "Array<DimensionLimit>"
        },
        {
            "name": "id",
            "baseName": "id",
            "type": "string"
        }
    ];
    return PlanPackage;
}());
exports.PlanPackage = PlanPackage;
var enumsMap = {
    "AccountSettings.TransitionTypeEnum": AccountSettings.TransitionTypeEnum,
    "DimensionLimit.DimensionEnum": DimensionLimit.DimensionEnum,
    "Event.EventTypeEnum": Event.EventTypeEnum,
    "Event.LogTypeEnum": Event.LogTypeEnum,
    "Filespace.SubscriptionTypeEnum": Filespace.SubscriptionTypeEnum,
    "Filespace.TypeEnum": Filespace.TypeEnum,
    "Filespace.StatusEnum": Filespace.StatusEnum,
    "Filespace.RenameStatusEnum": Filespace.RenameStatusEnum,
    "Filespace.SuspensionStatusEnum": Filespace.SuspensionStatusEnum,
    "FilespaceAuth.VerificationTypeEnum": FilespaceAuth.VerificationTypeEnum,
    "FilespaceAuth.OperationTypeEnum": FilespaceAuth.OperationTypeEnum,
    "FilespaceDeleteAuth.VerificationTypeEnum": FilespaceDeleteAuth.VerificationTypeEnum,
    "FilespaceLineItem.StorageOwnerEnum": FilespaceLineItem.StorageOwnerEnum,
    "FilespaceLineItem.SubscriptionTypeEnum": FilespaceLineItem.SubscriptionTypeEnum,
    "FilespaceStorage.OwnerEnum": FilespaceStorage.OwnerEnum,
    "FilespaceStorage.ClassEnum": FilespaceStorage.ClassEnum,
    "FilespaceStorage.ProviderEnum": FilespaceStorage.ProviderEnum,
    "FilespaceUsage.DimensionEnum": FilespaceUsage.DimensionEnum,
    "Invoice.PaymentStatusEnum": Invoice.PaymentStatusEnum,
    "PaymentDetails.PaymentMethodEnum": PaymentDetails.PaymentMethodEnum,
    "Plan.DimensionEnum": Plan.DimensionEnum,
    "PlanPackageCriterion.StorageOwnerEnum": PlanPackageCriterion.StorageOwnerEnum,
    "PlanPackageCriterion.SubscriptionTypeEnum": PlanPackageCriterion.SubscriptionTypeEnum,
    "PlanPackageUpdate.ActionEnum": PlanPackageUpdate.ActionEnum,
    "PlanUpdate.DimensionEnum": PlanUpdate.DimensionEnum,
    "PlanUpdate.ActionEnum": PlanUpdate.ActionEnum,
    "VerificationCode.VerificationTypeEnum": VerificationCode.VerificationTypeEnum,
    "VerificationRequired.VerificationTypeEnum": VerificationRequired.VerificationTypeEnum,
    "AdminUserSearchResultExtended.PaymentMethodsEnum": AdminUserSearchResultExtended.PaymentMethodsEnum,
    "FilespaceExtended.SubscriptionTypeEnum": FilespaceExtended.SubscriptionTypeEnum,
    "FilespaceExtended.TypeEnum": FilespaceExtended.TypeEnum,
    "FilespaceExtended.StatusEnum": FilespaceExtended.StatusEnum,
    "FilespaceExtended.RenameStatusEnum": FilespaceExtended.RenameStatusEnum,
    "FilespaceExtended.SuspensionStatusEnum": FilespaceExtended.SuspensionStatusEnum,
    "FilespaceLineItemWithForecast.StorageOwnerEnum": FilespaceLineItemWithForecast.StorageOwnerEnum,
    "FilespaceLineItemWithForecast.SubscriptionTypeEnum": FilespaceLineItemWithForecast.SubscriptionTypeEnum,
};
var typeMap = {
    "AccountSettings": AccountSettings,
    "AdminStatusRequired": AdminStatusRequired,
    "AdminUserSearchResult": AdminUserSearchResult,
    "AppcuesData": AppcuesData,
    "Attributes": Attributes,
    "BadRequest": BadRequest,
    "BillingAddress": BillingAddress,
    "BillingPeriod": BillingPeriod,
    "BillingPlan": BillingPlan,
    "BillingPlanUpdate": BillingPlanUpdate,
    "Card": Card,
    "CertificateSigningRequest": CertificateSigningRequest,
    "CertificateSigningResponse": CertificateSigningResponse,
    "CognitoIdToken": CognitoIdToken,
    "Conflict": Conflict,
    "DimensionLimit": DimensionLimit,
    "Domain": Domain,
    "DomainWithFilespaces": DomainWithFilespaces,
    "Event": Event,
    "Filespace": Filespace,
    "FilespaceAuth": FilespaceAuth,
    "FilespaceDeleteAuth": FilespaceDeleteAuth,
    "FilespaceLineItem": FilespaceLineItem,
    "FilespaceS3Region": FilespaceS3Region,
    "FilespaceStats": FilespaceStats,
    "FilespaceStorage": FilespaceStorage,
    "FilespaceUsage": FilespaceUsage,
    "Invoice": Invoice,
    "InvoiceID": InvoiceID,
    "NotFound": NotFound,
    "PaymentDetails": PaymentDetails,
    "PaymentRequired": PaymentRequired,
    "Plan": Plan,
    "PlanPackageCriterion": PlanPackageCriterion,
    "PlanPackageNoId": PlanPackageNoId,
    "PlanPackageUpdate": PlanPackageUpdate,
    "PlanTier": PlanTier,
    "PlanUpdate": PlanUpdate,
    "RemoteRekeyPayload": RemoteRekeyPayload,
    "UnprocessableEntity": UnprocessableEntity,
    "UserEmail": UserEmail,
    "UtmData": UtmData,
    "VerificationCode": VerificationCode,
    "VerificationRequired": VerificationRequired,
    "AdminUserSearchResultExtended": AdminUserSearchResultExtended,
    "FilespaceExtended": FilespaceExtended,
    "FilespaceLineItemWithForecast": FilespaceLineItemWithForecast,
    "PlanPackage": PlanPackage,
};
var HttpBasicAuth = /** @class */ (function () {
    function HttpBasicAuth() {
        this.username = '';
        this.password = '';
    }
    HttpBasicAuth.prototype.applyToRequest = function (requestOptions) {
        requestOptions.auth = {
            username: this.username, password: this.password
        };
    };
    return HttpBasicAuth;
}());
exports.HttpBasicAuth = HttpBasicAuth;
var ApiKeyAuth = /** @class */ (function () {
    function ApiKeyAuth(location, paramName) {
        this.location = location;
        this.paramName = paramName;
        this.apiKey = '';
    }
    ApiKeyAuth.prototype.applyToRequest = function (requestOptions) {
        if (this.location == "query") {
            requestOptions.qs[this.paramName] = this.apiKey;
        }
        else if (this.location == "header" && requestOptions && requestOptions.headers) {
            requestOptions.headers[this.paramName] = this.apiKey;
        }
    };
    return ApiKeyAuth;
}());
exports.ApiKeyAuth = ApiKeyAuth;
var OAuth = /** @class */ (function () {
    function OAuth() {
        this.accessToken = '';
    }
    OAuth.prototype.applyToRequest = function (requestOptions) {
        if (requestOptions && requestOptions.headers) {
            requestOptions.headers["Authorization"] = "Bearer " + this.accessToken;
        }
    };
    return OAuth;
}());
exports.OAuth = OAuth;
var VoidAuth = /** @class */ (function () {
    function VoidAuth() {
        this.username = '';
        this.password = '';
    }
    VoidAuth.prototype.applyToRequest = function (_) {
        // Do nothing
    };
    return VoidAuth;
}());
exports.VoidAuth = VoidAuth;
var BillingApiApiKeys;
(function (BillingApiApiKeys) {
})(BillingApiApiKeys = exports.BillingApiApiKeys || (exports.BillingApiApiKeys = {}));
var BillingApi = /** @class */ (function () {
    function BillingApi(basePathOrUsername, password, basePath) {
        this._basePath = defaultBasePath;
        this.defaultHeaders = {};
        this._useQuerystring = false;
        this.authentications = {
            'default': new VoidAuth(),
            'standard': new OAuth(),
        };
        if (password) {
            if (basePath) {
                this.basePath = basePath;
            }
        }
        else {
            if (basePathOrUsername) {
                this.basePath = basePathOrUsername;
            }
        }
    }
    Object.defineProperty(BillingApi.prototype, "useQuerystring", {
        set: function (value) {
            this._useQuerystring = value;
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(BillingApi.prototype, "basePath", {
        get: function () {
            return this._basePath;
        },
        set: function (basePath) {
            this._basePath = basePath;
        },
        enumerable: true,
        configurable: true
    });
    BillingApi.prototype.setDefaultAuthentication = function (auth) {
        this.authentications.default = auth;
    };
    BillingApi.prototype.setApiKey = function (key, value) {
        this.authentications[BillingApiApiKeys[key]].apiKey = value;
    };
    Object.defineProperty(BillingApi.prototype, "accessToken", {
        set: function (token) {
            this.authentications.standard.accessToken = token;
        },
        enumerable: true,
        configurable: true
    });
    /**
     *
     * @summary Get details about current billing period.
     */
    BillingApi.prototype.getCurrentPeriod = function () {
        var localVarPath = this.basePath + '/billing/current-period';
        var localVarQueryParameters = {};
        var localVarHeaderParams = Object.assign({}, this.defaultHeaders);
        var localVarFormParams = {};
        var localVarUseFormData = false;
        var localVarRequestOptions = {
            method: 'GET',
            qs: localVarQueryParameters,
            headers: localVarHeaderParams,
            uri: localVarPath,
            useQuerystring: this._useQuerystring,
            json: true,
        };
        this.authentications.standard.applyToRequest(localVarRequestOptions);
        this.authentications.default.applyToRequest(localVarRequestOptions);
        if (Object.keys(localVarFormParams).length) {
            if (localVarUseFormData) {
                localVarRequestOptions.formData = localVarFormParams;
            }
            else {
                localVarRequestOptions.form = localVarFormParams;
            }
        }
        return new Promise(function (resolve, reject) {
            localVarRequest(localVarRequestOptions, function (error, response, body) {
                if (error) {
                    reject(error);
                }
                else {
                    body = ObjectSerializer.deserialize(body, "BillingPeriod");
                    if (response.statusCode && response.statusCode >= 200 && response.statusCode <= 299) {
                        resolve({ response: response, body: body });
                    }
                    else {
                        reject({ response: response, body: body });
                    }
                }
            });
        });
    };
    /**
     *
     * @summary Retrieve an invoice cost breakdown by filespace.
     * @param id ID of the invoice.
     */
    BillingApi.prototype.getInvoiceBreakdownPerFilespace = function (id) {
        var localVarPath = this.basePath + '/billing/invoices/{id}/breakdown/csv'
            .replace('{' + 'id' + '}', encodeURIComponent(String(id)));
        var localVarQueryParameters = {};
        var localVarHeaderParams = Object.assign({}, this.defaultHeaders);
        var localVarFormParams = {};
        // verify required parameter 'id' is not null or undefined
        if (id === null || id === undefined) {
            throw new Error('Required parameter id was null or undefined when calling getInvoiceBreakdownPerFilespace.');
        }
        var localVarUseFormData = false;
        var localVarRequestOptions = {
            method: 'GET',
            qs: localVarQueryParameters,
            headers: localVarHeaderParams,
            uri: localVarPath,
            useQuerystring: this._useQuerystring,
            json: true,
        };
        this.authentications.standard.applyToRequest(localVarRequestOptions);
        this.authentications.default.applyToRequest(localVarRequestOptions);
        if (Object.keys(localVarFormParams).length) {
            if (localVarUseFormData) {
                localVarRequestOptions.formData = localVarFormParams;
            }
            else {
                localVarRequestOptions.form = localVarFormParams;
            }
        }
        return new Promise(function (resolve, reject) {
            localVarRequest(localVarRequestOptions, function (error, response, body) {
                if (error) {
                    reject(error);
                }
                else {
                    if (response.statusCode && response.statusCode >= 200 && response.statusCode <= 299) {
                        resolve({ response: response, body: body });
                    }
                    else {
                        reject({ response: response, body: body });
                    }
                }
            });
        });
    };
    /**
     *
     * @summary Get a list of issued invoices.
     */
    BillingApi.prototype.getInvoices = function () {
        var localVarPath = this.basePath + '/billing/invoices';
        var localVarQueryParameters = {};
        var localVarHeaderParams = Object.assign({}, this.defaultHeaders);
        var localVarFormParams = {};
        var localVarUseFormData = false;
        var localVarRequestOptions = {
            method: 'GET',
            qs: localVarQueryParameters,
            headers: localVarHeaderParams,
            uri: localVarPath,
            useQuerystring: this._useQuerystring,
            json: true,
        };
        this.authentications.standard.applyToRequest(localVarRequestOptions);
        this.authentications.default.applyToRequest(localVarRequestOptions);
        if (Object.keys(localVarFormParams).length) {
            if (localVarUseFormData) {
                localVarRequestOptions.formData = localVarFormParams;
            }
            else {
                localVarRequestOptions.form = localVarFormParams;
            }
        }
        return new Promise(function (resolve, reject) {
            localVarRequest(localVarRequestOptions, function (error, response, body) {
                if (error) {
                    reject(error);
                }
                else {
                    body = ObjectSerializer.deserialize(body, "Array<Invoice>");
                    if (response.statusCode && response.statusCode >= 200 && response.statusCode <= 299) {
                        resolve({ response: response, body: body });
                    }
                    else {
                        reject({ response: response, body: body });
                    }
                }
            });
        });
    };
    /**
     *
     * @summary Get payment details.
     */
    BillingApi.prototype.getPaymentDetails = function () {
        var localVarPath = this.basePath + '/billing/payment';
        var localVarQueryParameters = {};
        var localVarHeaderParams = Object.assign({}, this.defaultHeaders);
        var localVarFormParams = {};
        var localVarUseFormData = false;
        var localVarRequestOptions = {
            method: 'GET',
            qs: localVarQueryParameters,
            headers: localVarHeaderParams,
            uri: localVarPath,
            useQuerystring: this._useQuerystring,
            json: true,
        };
        this.authentications.standard.applyToRequest(localVarRequestOptions);
        this.authentications.default.applyToRequest(localVarRequestOptions);
        if (Object.keys(localVarFormParams).length) {
            if (localVarUseFormData) {
                localVarRequestOptions.formData = localVarFormParams;
            }
            else {
                localVarRequestOptions.form = localVarFormParams;
            }
        }
        return new Promise(function (resolve, reject) {
            localVarRequest(localVarRequestOptions, function (error, response, body) {
                if (error) {
                    reject(error);
                }
                else {
                    body = ObjectSerializer.deserialize(body, "PaymentDetails");
                    if (response.statusCode && response.statusCode >= 200 && response.statusCode <= 299) {
                        resolve({ response: response, body: body });
                    }
                    else {
                        reject({ response: response, body: body });
                    }
                }
            });
        });
    };
    /**
     *
     * @summary Manually pay a single invoice based on ID
     * @param id The id of the invoice to be paid
     */
    BillingApi.prototype.payInvoice = function (id) {
        var localVarPath = this.basePath + '/billing/invoices/pay';
        var localVarQueryParameters = {};
        var localVarHeaderParams = Object.assign({}, this.defaultHeaders);
        var localVarFormParams = {};
        // verify required parameter 'id' is not null or undefined
        if (id === null || id === undefined) {
            throw new Error('Required parameter id was null or undefined when calling payInvoice.');
        }
        var localVarUseFormData = false;
        var localVarRequestOptions = {
            method: 'POST',
            qs: localVarQueryParameters,
            headers: localVarHeaderParams,
            uri: localVarPath,
            useQuerystring: this._useQuerystring,
            json: true,
            body: ObjectSerializer.serialize(id, "InvoiceID")
        };
        this.authentications.standard.applyToRequest(localVarRequestOptions);
        this.authentications.default.applyToRequest(localVarRequestOptions);
        if (Object.keys(localVarFormParams).length) {
            if (localVarUseFormData) {
                localVarRequestOptions.formData = localVarFormParams;
            }
            else {
                localVarRequestOptions.form = localVarFormParams;
            }
        }
        return new Promise(function (resolve, reject) {
            localVarRequest(localVarRequestOptions, function (error, response, body) {
                if (error) {
                    reject(error);
                }
                else {
                    if (response.statusCode && response.statusCode >= 200 && response.statusCode <= 299) {
                        resolve({ response: response, body: body });
                    }
                    else {
                        reject({ response: response, body: body });
                    }
                }
            });
        });
    };
    /**
     *
     * @summary Update payment details.
     * @param body An object specifying the payment details object fields to update.
     */
    BillingApi.prototype.updatePaymentDetails = function (body) {
        var localVarPath = this.basePath + '/billing/payment';
        var localVarQueryParameters = {};
        var localVarHeaderParams = Object.assign({}, this.defaultHeaders);
        var localVarFormParams = {};
        // verify required parameter 'body' is not null or undefined
        if (body === null || body === undefined) {
            throw new Error('Required parameter body was null or undefined when calling updatePaymentDetails.');
        }
        var localVarUseFormData = false;
        var localVarRequestOptions = {
            method: 'PATCH',
            qs: localVarQueryParameters,
            headers: localVarHeaderParams,
            uri: localVarPath,
            useQuerystring: this._useQuerystring,
            json: true,
            body: ObjectSerializer.serialize(body, "PaymentDetails")
        };
        this.authentications.standard.applyToRequest(localVarRequestOptions);
        this.authentications.default.applyToRequest(localVarRequestOptions);
        if (Object.keys(localVarFormParams).length) {
            if (localVarUseFormData) {
                localVarRequestOptions.formData = localVarFormParams;
            }
            else {
                localVarRequestOptions.form = localVarFormParams;
            }
        }
        return new Promise(function (resolve, reject) {
            localVarRequest(localVarRequestOptions, function (error, response, body) {
                if (error) {
                    reject(error);
                }
                else {
                    if (response.statusCode && response.statusCode >= 200 && response.statusCode <= 299) {
                        resolve({ response: response, body: body });
                    }
                    else {
                        reject({ response: response, body: body });
                    }
                }
            });
        });
    };
    return BillingApi;
}());
exports.BillingApi = BillingApi;
var DefaultApiApiKeys;
(function (DefaultApiApiKeys) {
})(DefaultApiApiKeys = exports.DefaultApiApiKeys || (exports.DefaultApiApiKeys = {}));
var DefaultApi = /** @class */ (function () {
    function DefaultApi(basePathOrUsername, password, basePath) {
        this._basePath = defaultBasePath;
        this.defaultHeaders = {};
        this._useQuerystring = false;
        this.authentications = {
            'default': new VoidAuth(),
            'standard': new OAuth(),
        };
        if (password) {
            if (basePath) {
                this.basePath = basePath;
            }
        }
        else {
            if (basePathOrUsername) {
                this.basePath = basePathOrUsername;
            }
        }
    }
    Object.defineProperty(DefaultApi.prototype, "useQuerystring", {
        set: function (value) {
            this._useQuerystring = value;
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(DefaultApi.prototype, "basePath", {
        get: function () {
            return this._basePath;
        },
        set: function (basePath) {
            this._basePath = basePath;
        },
        enumerable: true,
        configurable: true
    });
    DefaultApi.prototype.setDefaultAuthentication = function (auth) {
        this.authentications.default = auth;
    };
    DefaultApi.prototype.setApiKey = function (key, value) {
        this.authentications[DefaultApiApiKeys[key]].apiKey = value;
    };
    Object.defineProperty(DefaultApi.prototype, "accessToken", {
        set: function (token) {
            this.authentications.standard.accessToken = token;
        },
        enumerable: true,
        configurable: true
    });
    /**
     *
     * @summary Create a new user
     */
    DefaultApi.prototype.createUser = function () {
        var localVarPath = this.basePath + '/users';
        var localVarQueryParameters = {};
        var localVarHeaderParams = Object.assign({}, this.defaultHeaders);
        var localVarFormParams = {};
        var localVarUseFormData = false;
        var localVarRequestOptions = {
            method: 'POST',
            qs: localVarQueryParameters,
            headers: localVarHeaderParams,
            uri: localVarPath,
            useQuerystring: this._useQuerystring,
            json: true,
        };
        this.authentications.standard.applyToRequest(localVarRequestOptions);
        this.authentications.default.applyToRequest(localVarRequestOptions);
        if (Object.keys(localVarFormParams).length) {
            if (localVarUseFormData) {
                localVarRequestOptions.formData = localVarFormParams;
            }
            else {
                localVarRequestOptions.form = localVarFormParams;
            }
        }
        return new Promise(function (resolve, reject) {
            localVarRequest(localVarRequestOptions, function (error, response, body) {
                if (error) {
                    reject(error);
                }
                else {
                    if (response.statusCode && response.statusCode >= 200 && response.statusCode <= 299) {
                        resolve({ response: response, body: body });
                    }
                    else {
                        reject({ response: response, body: body });
                    }
                }
            });
        });
    };
    /**
     *
     * @summary Send an authenticated message to be distributed to a notification system
     * @param message Message to be emitted
     */
    DefaultApi.prototype.emit = function (message) {
        var localVarPath = this.basePath + '/userevents';
        var localVarQueryParameters = {};
        var localVarHeaderParams = Object.assign({}, this.defaultHeaders);
        var localVarFormParams = {};
        // verify required parameter 'message' is not null or undefined
        if (message === null || message === undefined) {
            throw new Error('Required parameter message was null or undefined when calling emit.');
        }
        var localVarUseFormData = false;
        var localVarRequestOptions = {
            method: 'POST',
            qs: localVarQueryParameters,
            headers: localVarHeaderParams,
            uri: localVarPath,
            useQuerystring: this._useQuerystring,
            json: true,
            body: ObjectSerializer.serialize(message, "Event")
        };
        this.authentications.standard.applyToRequest(localVarRequestOptions);
        this.authentications.default.applyToRequest(localVarRequestOptions);
        if (Object.keys(localVarFormParams).length) {
            if (localVarUseFormData) {
                localVarRequestOptions.formData = localVarFormParams;
            }
            else {
                localVarRequestOptions.form = localVarFormParams;
            }
        }
        return new Promise(function (resolve, reject) {
            localVarRequest(localVarRequestOptions, function (error, response, body) {
                if (error) {
                    reject(error);
                }
                else {
                    body = ObjectSerializer.deserialize(body, "any");
                    if (response.statusCode && response.statusCode >= 200 && response.statusCode <= 299) {
                        resolve({ response: response, body: body });
                    }
                    else {
                        reject({ response: response, body: body });
                    }
                }
            });
        });
    };
    /**
     *
     * @summary Get the current user object.
     */
    DefaultApi.prototype.getAccountSettings = function () {
        var localVarPath = this.basePath + '/settings/account';
        var localVarQueryParameters = {};
        var localVarHeaderParams = Object.assign({}, this.defaultHeaders);
        var localVarFormParams = {};
        var localVarUseFormData = false;
        var localVarRequestOptions = {
            method: 'GET',
            qs: localVarQueryParameters,
            headers: localVarHeaderParams,
            uri: localVarPath,
            useQuerystring: this._useQuerystring,
            json: true,
        };
        this.authentications.standard.applyToRequest(localVarRequestOptions);
        this.authentications.default.applyToRequest(localVarRequestOptions);
        if (Object.keys(localVarFormParams).length) {
            if (localVarUseFormData) {
                localVarRequestOptions.formData = localVarFormParams;
            }
            else {
                localVarRequestOptions.form = localVarFormParams;
            }
        }
        return new Promise(function (resolve, reject) {
            localVarRequest(localVarRequestOptions, function (error, response, body) {
                if (error) {
                    reject(error);
                }
                else {
                    body = ObjectSerializer.deserialize(body, "AccountSettings");
                    if (response.statusCode && response.statusCode >= 200 && response.statusCode <= 299) {
                        resolve({ response: response, body: body });
                    }
                    else {
                        reject({ response: response, body: body });
                    }
                }
            });
        });
    };
    /**
     *
     * @summary Get info needed for Appcues identification
     */
    DefaultApi.prototype.getAppcuesData = function () {
        var localVarPath = this.basePath + '/users/appcues';
        var localVarQueryParameters = {};
        var localVarHeaderParams = Object.assign({}, this.defaultHeaders);
        var localVarFormParams = {};
        var localVarUseFormData = false;
        var localVarRequestOptions = {
            method: 'GET',
            qs: localVarQueryParameters,
            headers: localVarHeaderParams,
            uri: localVarPath,
            useQuerystring: this._useQuerystring,
            json: true,
        };
        this.authentications.standard.applyToRequest(localVarRequestOptions);
        this.authentications.default.applyToRequest(localVarRequestOptions);
        if (Object.keys(localVarFormParams).length) {
            if (localVarUseFormData) {
                localVarRequestOptions.formData = localVarFormParams;
            }
            else {
                localVarRequestOptions.form = localVarFormParams;
            }
        }
        return new Promise(function (resolve, reject) {
            localVarRequest(localVarRequestOptions, function (error, response, body) {
                if (error) {
                    reject(error);
                }
                else {
                    body = ObjectSerializer.deserialize(body, "AppcuesData");
                    if (response.statusCode && response.statusCode >= 200 && response.statusCode <= 299) {
                        resolve({ response: response, body: body });
                    }
                    else {
                        reject({ response: response, body: body });
                    }
                }
            });
        });
    };
    /**
     *
     * @summary Get user attributes
     */
    DefaultApi.prototype.getAttributes = function () {
        var localVarPath = this.basePath + '/attributes';
        var localVarQueryParameters = {};
        var localVarHeaderParams = Object.assign({}, this.defaultHeaders);
        var localVarFormParams = {};
        var localVarUseFormData = false;
        var localVarRequestOptions = {
            method: 'GET',
            qs: localVarQueryParameters,
            headers: localVarHeaderParams,
            uri: localVarPath,
            useQuerystring: this._useQuerystring,
            json: true,
        };
        this.authentications.standard.applyToRequest(localVarRequestOptions);
        this.authentications.default.applyToRequest(localVarRequestOptions);
        if (Object.keys(localVarFormParams).length) {
            if (localVarUseFormData) {
                localVarRequestOptions.formData = localVarFormParams;
            }
            else {
                localVarRequestOptions.form = localVarFormParams;
            }
        }
        return new Promise(function (resolve, reject) {
            localVarRequest(localVarRequestOptions, function (error, response, body) {
                if (error) {
                    reject(error);
                }
                else {
                    body = ObjectSerializer.deserialize(body, "Attributes");
                    if (response.statusCode && response.statusCode >= 200 && response.statusCode <= 299) {
                        resolve({ response: response, body: body });
                    }
                    else {
                        reject({ response: response, body: body });
                    }
                }
            });
        });
    };
    /**
     *
     * @summary Admin get user domains and filespaces.
     * @param userId User id
     */
    DefaultApi.prototype.getDomainsByUserId = function (userId) {
        var localVarPath = this.basePath + '/admin/domains';
        var localVarQueryParameters = {};
        var localVarHeaderParams = Object.assign({}, this.defaultHeaders);
        var localVarFormParams = {};
        // verify required parameter 'userId' is not null or undefined
        if (userId === null || userId === undefined) {
            throw new Error('Required parameter userId was null or undefined when calling getDomainsByUserId.');
        }
        if (userId !== undefined) {
            localVarQueryParameters['userId'] = ObjectSerializer.serialize(userId, "string");
        }
        var localVarUseFormData = false;
        var localVarRequestOptions = {
            method: 'GET',
            qs: localVarQueryParameters,
            headers: localVarHeaderParams,
            uri: localVarPath,
            useQuerystring: this._useQuerystring,
            json: true,
        };
        this.authentications.standard.applyToRequest(localVarRequestOptions);
        this.authentications.default.applyToRequest(localVarRequestOptions);
        if (Object.keys(localVarFormParams).length) {
            if (localVarUseFormData) {
                localVarRequestOptions.formData = localVarFormParams;
            }
            else {
                localVarRequestOptions.form = localVarFormParams;
            }
        }
        return new Promise(function (resolve, reject) {
            localVarRequest(localVarRequestOptions, function (error, response, body) {
                if (error) {
                    reject(error);
                }
                else {
                    body = ObjectSerializer.deserialize(body, "Array<DomainWithFilespaces>");
                    if (response.statusCode && response.statusCode >= 200 && response.statusCode <= 299) {
                        resolve({ response: response, body: body });
                    }
                    else {
                        reject({ response: response, body: body });
                    }
                }
            });
        });
    };
    /**
     *
     * @summary Admin get domain and filespace by UUID
     * @param uuid Filespace UUID
     */
    DefaultApi.prototype.getFilespaceByUUID = function (uuid) {
        var localVarPath = this.basePath + '/admin/filespaceByUUID';
        var localVarQueryParameters = {};
        var localVarHeaderParams = Object.assign({}, this.defaultHeaders);
        var localVarFormParams = {};
        // verify required parameter 'uuid' is not null or undefined
        if (uuid === null || uuid === undefined) {
            throw new Error('Required parameter uuid was null or undefined when calling getFilespaceByUUID.');
        }
        if (uuid !== undefined) {
            localVarQueryParameters['uuid'] = ObjectSerializer.serialize(uuid, "string");
        }
        var localVarUseFormData = false;
        var localVarRequestOptions = {
            method: 'GET',
            qs: localVarQueryParameters,
            headers: localVarHeaderParams,
            uri: localVarPath,
            useQuerystring: this._useQuerystring,
            json: true,
        };
        this.authentications.standard.applyToRequest(localVarRequestOptions);
        this.authentications.default.applyToRequest(localVarRequestOptions);
        if (Object.keys(localVarFormParams).length) {
            if (localVarUseFormData) {
                localVarRequestOptions.formData = localVarFormParams;
            }
            else {
                localVarRequestOptions.form = localVarFormParams;
            }
        }
        return new Promise(function (resolve, reject) {
            localVarRequest(localVarRequestOptions, function (error, response, body) {
                if (error) {
                    reject(error);
                }
                else {
                    body = ObjectSerializer.deserialize(body, "Array<DomainWithFilespaces>");
                    if (response.statusCode && response.statusCode >= 200 && response.statusCode <= 299) {
                        resolve({ response: response, body: body });
                    }
                    else {
                        reject({ response: response, body: body });
                    }
                }
            });
        });
    };
    /**
     *
     * @summary Admin get domain, filespaces and user by filespace name
     * @param filespaceName Filespace name
     */
    DefaultApi.prototype.getFilespacesByFilespaceName = function (filespaceName) {
        var localVarPath = this.basePath + '/admin/filespacesByName';
        var localVarQueryParameters = {};
        var localVarHeaderParams = Object.assign({}, this.defaultHeaders);
        var localVarFormParams = {};
        // verify required parameter 'filespaceName' is not null or undefined
        if (filespaceName === null || filespaceName === undefined) {
            throw new Error('Required parameter filespaceName was null or undefined when calling getFilespacesByFilespaceName.');
        }
        if (filespaceName !== undefined) {
            localVarQueryParameters['filespaceName'] = ObjectSerializer.serialize(filespaceName, "string");
        }
        var localVarUseFormData = false;
        var localVarRequestOptions = {
            method: 'GET',
            qs: localVarQueryParameters,
            headers: localVarHeaderParams,
            uri: localVarPath,
            useQuerystring: this._useQuerystring,
            json: true,
        };
        this.authentications.standard.applyToRequest(localVarRequestOptions);
        this.authentications.default.applyToRequest(localVarRequestOptions);
        if (Object.keys(localVarFormParams).length) {
            if (localVarUseFormData) {
                localVarRequestOptions.formData = localVarFormParams;
            }
            else {
                localVarRequestOptions.form = localVarFormParams;
            }
        }
        return new Promise(function (resolve, reject) {
            localVarRequest(localVarRequestOptions, function (error, response, body) {
                if (error) {
                    reject(error);
                }
                else {
                    body = ObjectSerializer.deserialize(body, "Array<DomainWithFilespaces>");
                    if (response.statusCode && response.statusCode >= 200 && response.statusCode <= 299) {
                        resolve({ response: response, body: body });
                    }
                    else {
                        reject({ response: response, body: body });
                    }
                }
            });
        });
    };
    /**
     *
     * @summary Retrieve the billing forecast for a user by id
     * @param userId User id
     */
    DefaultApi.prototype.getForecast = function (userId) {
        var localVarPath = this.basePath + '/admin/billingForecast';
        var localVarQueryParameters = {};
        var localVarHeaderParams = Object.assign({}, this.defaultHeaders);
        var localVarFormParams = {};
        // verify required parameter 'userId' is not null or undefined
        if (userId === null || userId === undefined) {
            throw new Error('Required parameter userId was null or undefined when calling getForecast.');
        }
        if (userId !== undefined) {
            localVarQueryParameters['userId'] = ObjectSerializer.serialize(userId, "string");
        }
        var localVarUseFormData = false;
        var localVarRequestOptions = {
            method: 'GET',
            qs: localVarQueryParameters,
            headers: localVarHeaderParams,
            uri: localVarPath,
            useQuerystring: this._useQuerystring,
            json: true,
        };
        this.authentications.standard.applyToRequest(localVarRequestOptions);
        this.authentications.default.applyToRequest(localVarRequestOptions);
        if (Object.keys(localVarFormParams).length) {
            if (localVarUseFormData) {
                localVarRequestOptions.formData = localVarFormParams;
            }
            else {
                localVarRequestOptions.form = localVarFormParams;
            }
        }
        return new Promise(function (resolve, reject) {
            localVarRequest(localVarRequestOptions, function (error, response, body) {
                if (error) {
                    reject(error);
                }
                else {
                    body = ObjectSerializer.deserialize(body, "any");
                    if (response.statusCode && response.statusCode >= 200 && response.statusCode <= 299) {
                        resolve({ response: response, body: body });
                    }
                    else {
                        reject({ response: response, body: body });
                    }
                }
            });
        });
    };
    /**
     *
     * @summary Get invoice breakdown csv
     * @param id ID of the invoice for breakdown
     */
    DefaultApi.prototype.getInvoiceBreakdownCSV = function (id) {
        var localVarPath = this.basePath + '/admin/invoices/{id}/breakdown/csv'
            .replace('{' + 'id' + '}', encodeURIComponent(String(id)));
        var localVarQueryParameters = {};
        var localVarHeaderParams = Object.assign({}, this.defaultHeaders);
        var localVarFormParams = {};
        // verify required parameter 'id' is not null or undefined
        if (id === null || id === undefined) {
            throw new Error('Required parameter id was null or undefined when calling getInvoiceBreakdownCSV.');
        }
        var localVarUseFormData = false;
        var localVarRequestOptions = {
            method: 'GET',
            qs: localVarQueryParameters,
            headers: localVarHeaderParams,
            uri: localVarPath,
            useQuerystring: this._useQuerystring,
            json: true,
        };
        this.authentications.standard.applyToRequest(localVarRequestOptions);
        this.authentications.default.applyToRequest(localVarRequestOptions);
        if (Object.keys(localVarFormParams).length) {
            if (localVarUseFormData) {
                localVarRequestOptions.formData = localVarFormParams;
            }
            else {
                localVarRequestOptions.form = localVarFormParams;
            }
        }
        return new Promise(function (resolve, reject) {
            localVarRequest(localVarRequestOptions, function (error, response, body) {
                if (error) {
                    reject(error);
                }
                else {
                    if (response.statusCode && response.statusCode >= 200 && response.statusCode <= 299) {
                        resolve({ response: response, body: body });
                    }
                    else {
                        reject({ response: response, body: body });
                    }
                }
            });
        });
    };
    /**
     *
     * @summary Admin get is billing enabled for a filespace
     * @param filespaceId Filespace id
     */
    DefaultApi.prototype.getIsBillingEnabled = function (filespaceId) {
        var localVarPath = this.basePath + '/admin/isBillingEnabled';
        var localVarQueryParameters = {};
        var localVarHeaderParams = Object.assign({}, this.defaultHeaders);
        var localVarFormParams = {};
        // verify required parameter 'filespaceId' is not null or undefined
        if (filespaceId === null || filespaceId === undefined) {
            throw new Error('Required parameter filespaceId was null or undefined when calling getIsBillingEnabled.');
        }
        if (filespaceId !== undefined) {
            localVarQueryParameters['filespaceId'] = ObjectSerializer.serialize(filespaceId, "string");
        }
        var localVarUseFormData = false;
        var localVarRequestOptions = {
            method: 'GET',
            qs: localVarQueryParameters,
            headers: localVarHeaderParams,
            uri: localVarPath,
            useQuerystring: this._useQuerystring,
            json: true,
        };
        this.authentications.standard.applyToRequest(localVarRequestOptions);
        this.authentications.default.applyToRequest(localVarRequestOptions);
        if (Object.keys(localVarFormParams).length) {
            if (localVarUseFormData) {
                localVarRequestOptions.formData = localVarFormParams;
            }
            else {
                localVarRequestOptions.form = localVarFormParams;
            }
        }
        return new Promise(function (resolve, reject) {
            localVarRequest(localVarRequestOptions, function (error, response, body) {
                if (error) {
                    reject(error);
                }
                else {
                    body = ObjectSerializer.deserialize(body, "boolean");
                    if (response.statusCode && response.statusCode >= 200 && response.statusCode <= 299) {
                        resolve({ response: response, body: body });
                    }
                    else {
                        reject({ response: response, body: body });
                    }
                }
            });
        });
    };
    /**
     *
     * @summary Get a dictionary with settings.
     */
    DefaultApi.prototype.getSettings = function () {
        var localVarPath = this.basePath + '/settings';
        var localVarQueryParameters = {};
        var localVarHeaderParams = Object.assign({}, this.defaultHeaders);
        var localVarFormParams = {};
        var localVarUseFormData = false;
        var localVarRequestOptions = {
            method: 'GET',
            qs: localVarQueryParameters,
            headers: localVarHeaderParams,
            uri: localVarPath,
            useQuerystring: this._useQuerystring,
            json: true,
        };
        this.authentications.standard.applyToRequest(localVarRequestOptions);
        this.authentications.default.applyToRequest(localVarRequestOptions);
        if (Object.keys(localVarFormParams).length) {
            if (localVarUseFormData) {
                localVarRequestOptions.formData = localVarFormParams;
            }
            else {
                localVarRequestOptions.form = localVarFormParams;
            }
        }
        return new Promise(function (resolve, reject) {
            localVarRequest(localVarRequestOptions, function (error, response, body) {
                if (error) {
                    reject(error);
                }
                else {
                    body = ObjectSerializer.deserialize(body, "any");
                    if (response.statusCode && response.statusCode >= 200 && response.statusCode <= 299) {
                        resolve({ response: response, body: body });
                    }
                    else {
                        reject({ response: response, body: body });
                    }
                }
            });
        });
    };
    /**
     *
     * @summary Retrieve extra user details by user id.
     * @param id User id
     */
    DefaultApi.prototype.getUserAdditionalInformationById = function (id) {
        var localVarPath = this.basePath + '/admin/userDetailsExtra';
        var localVarQueryParameters = {};
        var localVarHeaderParams = Object.assign({}, this.defaultHeaders);
        var localVarFormParams = {};
        // verify required parameter 'id' is not null or undefined
        if (id === null || id === undefined) {
            throw new Error('Required parameter id was null or undefined when calling getUserAdditionalInformationById.');
        }
        if (id !== undefined) {
            localVarQueryParameters['id'] = ObjectSerializer.serialize(id, "string");
        }
        var localVarUseFormData = false;
        var localVarRequestOptions = {
            method: 'GET',
            qs: localVarQueryParameters,
            headers: localVarHeaderParams,
            uri: localVarPath,
            useQuerystring: this._useQuerystring,
            json: true,
        };
        this.authentications.standard.applyToRequest(localVarRequestOptions);
        this.authentications.default.applyToRequest(localVarRequestOptions);
        if (Object.keys(localVarFormParams).length) {
            if (localVarUseFormData) {
                localVarRequestOptions.formData = localVarFormParams;
            }
            else {
                localVarRequestOptions.form = localVarFormParams;
            }
        }
        return new Promise(function (resolve, reject) {
            localVarRequest(localVarRequestOptions, function (error, response, body) {
                if (error) {
                    reject(error);
                }
                else {
                    body = ObjectSerializer.deserialize(body, "AdminUserSearchResultExtended");
                    if (response.statusCode && response.statusCode >= 200 && response.statusCode <= 299) {
                        resolve({ response: response, body: body });
                    }
                    else {
                        reject({ response: response, body: body });
                    }
                }
            });
        });
    };
    /**
     *
     * @summary Admin get user billing plan
     * @param userId User id
     */
    DefaultApi.prototype.getUserBillingPlan = function (userId) {
        var localVarPath = this.basePath + '/admin/billingPlan';
        var localVarQueryParameters = {};
        var localVarHeaderParams = Object.assign({}, this.defaultHeaders);
        var localVarFormParams = {};
        // verify required parameter 'userId' is not null or undefined
        if (userId === null || userId === undefined) {
            throw new Error('Required parameter userId was null or undefined when calling getUserBillingPlan.');
        }
        if (userId !== undefined) {
            localVarQueryParameters['userId'] = ObjectSerializer.serialize(userId, "string");
        }
        var localVarUseFormData = false;
        var localVarRequestOptions = {
            method: 'GET',
            qs: localVarQueryParameters,
            headers: localVarHeaderParams,
            uri: localVarPath,
            useQuerystring: this._useQuerystring,
            json: true,
        };
        this.authentications.standard.applyToRequest(localVarRequestOptions);
        this.authentications.default.applyToRequest(localVarRequestOptions);
        if (Object.keys(localVarFormParams).length) {
            if (localVarUseFormData) {
                localVarRequestOptions.formData = localVarFormParams;
            }
            else {
                localVarRequestOptions.form = localVarFormParams;
            }
        }
        return new Promise(function (resolve, reject) {
            localVarRequest(localVarRequestOptions, function (error, response, body) {
                if (error) {
                    reject(error);
                }
                else {
                    body = ObjectSerializer.deserialize(body, "BillingPlan");
                    if (response.statusCode && response.statusCode >= 200 && response.statusCode <= 299) {
                        resolve({ response: response, body: body });
                    }
                    else {
                        reject({ response: response, body: body });
                    }
                }
            });
        });
    };
    /**
     *
     * @summary Get user by domain name
     * @param domainName The name of the domain
     */
    DefaultApi.prototype.getUserByDomainName = function (domainName) {
        var localVarPath = this.basePath + '/admin/userByDomainName';
        var localVarQueryParameters = {};
        var localVarHeaderParams = Object.assign({}, this.defaultHeaders);
        var localVarFormParams = {};
        // verify required parameter 'domainName' is not null or undefined
        if (domainName === null || domainName === undefined) {
            throw new Error('Required parameter domainName was null or undefined when calling getUserByDomainName.');
        }
        if (domainName !== undefined) {
            localVarQueryParameters['domainName'] = ObjectSerializer.serialize(domainName, "string");
        }
        var localVarUseFormData = false;
        var localVarRequestOptions = {
            method: 'GET',
            qs: localVarQueryParameters,
            headers: localVarHeaderParams,
            uri: localVarPath,
            useQuerystring: this._useQuerystring,
            json: true,
        };
        this.authentications.standard.applyToRequest(localVarRequestOptions);
        this.authentications.default.applyToRequest(localVarRequestOptions);
        if (Object.keys(localVarFormParams).length) {
            if (localVarUseFormData) {
                localVarRequestOptions.formData = localVarFormParams;
            }
            else {
                localVarRequestOptions.form = localVarFormParams;
            }
        }
        return new Promise(function (resolve, reject) {
            localVarRequest(localVarRequestOptions, function (error, response, body) {
                if (error) {
                    reject(error);
                }
                else {
                    if (response.statusCode && response.statusCode >= 200 && response.statusCode <= 299) {
                        resolve({ response: response, body: body });
                    }
                    else {
                        reject({ response: response, body: body });
                    }
                }
            });
        });
    };
    /**
     *
     * @summary Admin get user invoices
     * @param userId User id
     */
    DefaultApi.prototype.getUserInvoices = function (userId) {
        var localVarPath = this.basePath + '/admin/invoices';
        var localVarQueryParameters = {};
        var localVarHeaderParams = Object.assign({}, this.defaultHeaders);
        var localVarFormParams = {};
        // verify required parameter 'userId' is not null or undefined
        if (userId === null || userId === undefined) {
            throw new Error('Required parameter userId was null or undefined when calling getUserInvoices.');
        }
        if (userId !== undefined) {
            localVarQueryParameters['userId'] = ObjectSerializer.serialize(userId, "string");
        }
        var localVarUseFormData = false;
        var localVarRequestOptions = {
            method: 'GET',
            qs: localVarQueryParameters,
            headers: localVarHeaderParams,
            uri: localVarPath,
            useQuerystring: this._useQuerystring,
            json: true,
        };
        this.authentications.standard.applyToRequest(localVarRequestOptions);
        this.authentications.default.applyToRequest(localVarRequestOptions);
        if (Object.keys(localVarFormParams).length) {
            if (localVarUseFormData) {
                localVarRequestOptions.formData = localVarFormParams;
            }
            else {
                localVarRequestOptions.form = localVarFormParams;
            }
        }
        return new Promise(function (resolve, reject) {
            localVarRequest(localVarRequestOptions, function (error, response, body) {
                if (error) {
                    reject(error);
                }
                else {
                    body = ObjectSerializer.deserialize(body, "Array<Invoice>");
                    if (response.statusCode && response.statusCode >= 200 && response.statusCode <= 299) {
                        resolve({ response: response, body: body });
                    }
                    else {
                        reject({ response: response, body: body });
                    }
                }
            });
        });
    };
    /**
     *
     * @summary Get the payment details of a user
     * @param userId
     */
    DefaultApi.prototype.getUserPaymentDetails = function (userId) {
        var localVarPath = this.basePath + '/admin/paymentDetails';
        var localVarQueryParameters = {};
        var localVarHeaderParams = Object.assign({}, this.defaultHeaders);
        var localVarFormParams = {};
        // verify required parameter 'userId' is not null or undefined
        if (userId === null || userId === undefined) {
            throw new Error('Required parameter userId was null or undefined when calling getUserPaymentDetails.');
        }
        if (userId !== undefined) {
            localVarQueryParameters['userId'] = ObjectSerializer.serialize(userId, "string");
        }
        var localVarUseFormData = false;
        var localVarRequestOptions = {
            method: 'GET',
            qs: localVarQueryParameters,
            headers: localVarHeaderParams,
            uri: localVarPath,
            useQuerystring: this._useQuerystring,
            json: true,
        };
        this.authentications.standard.applyToRequest(localVarRequestOptions);
        this.authentications.default.applyToRequest(localVarRequestOptions);
        if (Object.keys(localVarFormParams).length) {
            if (localVarUseFormData) {
                localVarRequestOptions.formData = localVarFormParams;
            }
            else {
                localVarRequestOptions.form = localVarFormParams;
            }
        }
        return new Promise(function (resolve, reject) {
            localVarRequest(localVarRequestOptions, function (error, response, body) {
                if (error) {
                    reject(error);
                }
                else {
                    body = ObjectSerializer.deserialize(body, "PaymentDetails");
                    if (response.statusCode && response.statusCode >= 200 && response.statusCode <= 299) {
                        resolve({ response: response, body: body });
                    }
                    else {
                        reject({ response: response, body: body });
                    }
                }
            });
        });
    };
    /**
     *
     * @summary Retrieve users by the given email.
     * @param email User email
     */
    DefaultApi.prototype.getUsersByEmail = function (email) {
        var localVarPath = this.basePath + '/admin/users';
        var localVarQueryParameters = {};
        var localVarHeaderParams = Object.assign({}, this.defaultHeaders);
        var localVarFormParams = {};
        // verify required parameter 'email' is not null or undefined
        if (email === null || email === undefined) {
            throw new Error('Required parameter email was null or undefined when calling getUsersByEmail.');
        }
        if (email !== undefined) {
            localVarQueryParameters['email'] = ObjectSerializer.serialize(email, "string");
        }
        var localVarUseFormData = false;
        var localVarRequestOptions = {
            method: 'GET',
            qs: localVarQueryParameters,
            headers: localVarHeaderParams,
            uri: localVarPath,
            useQuerystring: this._useQuerystring,
            json: true,
        };
        this.authentications.standard.applyToRequest(localVarRequestOptions);
        this.authentications.default.applyToRequest(localVarRequestOptions);
        if (Object.keys(localVarFormParams).length) {
            if (localVarUseFormData) {
                localVarRequestOptions.formData = localVarFormParams;
            }
            else {
                localVarRequestOptions.form = localVarFormParams;
            }
        }
        return new Promise(function (resolve, reject) {
            localVarRequest(localVarRequestOptions, function (error, response, body) {
                if (error) {
                    reject(error);
                }
                else {
                    body = ObjectSerializer.deserialize(body, "Array<AdminUserSearchResult>");
                    if (response.statusCode && response.statusCode >= 200 && response.statusCode <= 299) {
                        resolve({ response: response, body: body });
                    }
                    else {
                        reject({ response: response, body: body });
                    }
                }
            });
        });
    };
    /**
     *
     * @summary Retrieve a user's billing information.
     * @param email User email
     */
    DefaultApi.prototype.getUsersDetailsByEmail = function (email) {
        var localVarPath = this.basePath + '/admin/userDetails';
        var localVarQueryParameters = {};
        var localVarHeaderParams = Object.assign({}, this.defaultHeaders);
        var localVarFormParams = {};
        // verify required parameter 'email' is not null or undefined
        if (email === null || email === undefined) {
            throw new Error('Required parameter email was null or undefined when calling getUsersDetailsByEmail.');
        }
        if (email !== undefined) {
            localVarQueryParameters['email'] = ObjectSerializer.serialize(email, "string");
        }
        var localVarUseFormData = false;
        var localVarRequestOptions = {
            method: 'GET',
            qs: localVarQueryParameters,
            headers: localVarHeaderParams,
            uri: localVarPath,
            useQuerystring: this._useQuerystring,
            json: true,
        };
        this.authentications.standard.applyToRequest(localVarRequestOptions);
        this.authentications.default.applyToRequest(localVarRequestOptions);
        if (Object.keys(localVarFormParams).length) {
            if (localVarUseFormData) {
                localVarRequestOptions.formData = localVarFormParams;
            }
            else {
                localVarRequestOptions.form = localVarFormParams;
            }
        }
        return new Promise(function (resolve, reject) {
            localVarRequest(localVarRequestOptions, function (error, response, body) {
                if (error) {
                    reject(error);
                }
                else {
                    body = ObjectSerializer.deserialize(body, "Array<AdminUserSearchResult>");
                    if (response.statusCode && response.statusCode >= 200 && response.statusCode <= 299) {
                        resolve({ response: response, body: body });
                    }
                    else {
                        reject({ response: response, body: body });
                    }
                }
            });
        });
    };
    /**
     *
     * @summary Delete a user's webportal account
     * @param id ID of the user
     */
    DefaultApi.prototype.removeAccount = function (id) {
        var localVarPath = this.basePath + '/admin/users/{id}'
            .replace('{' + 'id' + '}', encodeURIComponent(String(id)));
        var localVarQueryParameters = {};
        var localVarHeaderParams = Object.assign({}, this.defaultHeaders);
        var localVarFormParams = {};
        // verify required parameter 'id' is not null or undefined
        if (id === null || id === undefined) {
            throw new Error('Required parameter id was null or undefined when calling removeAccount.');
        }
        var localVarUseFormData = false;
        var localVarRequestOptions = {
            method: 'DELETE',
            qs: localVarQueryParameters,
            headers: localVarHeaderParams,
            uri: localVarPath,
            useQuerystring: this._useQuerystring,
            json: true,
        };
        this.authentications.standard.applyToRequest(localVarRequestOptions);
        this.authentications.default.applyToRequest(localVarRequestOptions);
        if (Object.keys(localVarFormParams).length) {
            if (localVarUseFormData) {
                localVarRequestOptions.formData = localVarFormParams;
            }
            else {
                localVarRequestOptions.form = localVarFormParams;
            }
        }
        return new Promise(function (resolve, reject) {
            localVarRequest(localVarRequestOptions, function (error, response, body) {
                if (error) {
                    reject(error);
                }
                else {
                    if (response.statusCode && response.statusCode >= 200 && response.statusCode <= 299) {
                        resolve({ response: response, body: body });
                    }
                    else {
                        reject({ response: response, body: body });
                    }
                }
            });
        });
    };
    /**
     *
     * @summary Retrieve and report a hub's ip.
     * @param domainName the domain name
     * @param filespaceName The filespace name
     */
    DefaultApi.prototype.reportHubStats = function (domainName, filespaceName) {
        var localVarPath = this.basePath + '/admin/hubStats';
        var localVarQueryParameters = {};
        var localVarHeaderParams = Object.assign({}, this.defaultHeaders);
        var localVarFormParams = {};
        // verify required parameter 'domainName' is not null or undefined
        if (domainName === null || domainName === undefined) {
            throw new Error('Required parameter domainName was null or undefined when calling reportHubStats.');
        }
        // verify required parameter 'filespaceName' is not null or undefined
        if (filespaceName === null || filespaceName === undefined) {
            throw new Error('Required parameter filespaceName was null or undefined when calling reportHubStats.');
        }
        if (domainName !== undefined) {
            localVarQueryParameters['domainName'] = ObjectSerializer.serialize(domainName, "string");
        }
        if (filespaceName !== undefined) {
            localVarQueryParameters['filespaceName'] = ObjectSerializer.serialize(filespaceName, "string");
        }
        var localVarUseFormData = false;
        var localVarRequestOptions = {
            method: 'GET',
            qs: localVarQueryParameters,
            headers: localVarHeaderParams,
            uri: localVarPath,
            useQuerystring: this._useQuerystring,
            json: true,
        };
        this.authentications.standard.applyToRequest(localVarRequestOptions);
        this.authentications.default.applyToRequest(localVarRequestOptions);
        if (Object.keys(localVarFormParams).length) {
            if (localVarUseFormData) {
                localVarRequestOptions.formData = localVarFormParams;
            }
            else {
                localVarRequestOptions.form = localVarFormParams;
            }
        }
        return new Promise(function (resolve, reject) {
            localVarRequest(localVarRequestOptions, function (error, response, body) {
                if (error) {
                    reject(error);
                }
                else {
                    body = ObjectSerializer.deserialize(body, "any");
                    if (response.statusCode && response.statusCode >= 200 && response.statusCode <= 299) {
                        resolve({ response: response, body: body });
                    }
                    else {
                        reject({ response: response, body: body });
                    }
                }
            });
        });
    };
    /**
     *
     * @summary Manually trigger hub preprovision
     * @param id the Filespace id
     */
    DefaultApi.prototype.reprovisionHub = function (id) {
        var localVarPath = this.basePath + '/filespaces/reprovisionHub/{id}'
            .replace('{' + 'id' + '}', encodeURIComponent(String(id)));
        var localVarQueryParameters = {};
        var localVarHeaderParams = Object.assign({}, this.defaultHeaders);
        var localVarFormParams = {};
        // verify required parameter 'id' is not null or undefined
        if (id === null || id === undefined) {
            throw new Error('Required parameter id was null or undefined when calling reprovisionHub.');
        }
        var localVarUseFormData = false;
        var localVarRequestOptions = {
            method: 'PATCH',
            qs: localVarQueryParameters,
            headers: localVarHeaderParams,
            uri: localVarPath,
            useQuerystring: this._useQuerystring,
            json: true,
        };
        this.authentications.standard.applyToRequest(localVarRequestOptions);
        this.authentications.default.applyToRequest(localVarRequestOptions);
        if (Object.keys(localVarFormParams).length) {
            if (localVarUseFormData) {
                localVarRequestOptions.formData = localVarFormParams;
            }
            else {
                localVarRequestOptions.form = localVarFormParams;
            }
        }
        return new Promise(function (resolve, reject) {
            localVarRequest(localVarRequestOptions, function (error, response, body) {
                if (error) {
                    reject(error);
                }
                else {
                    if (response.statusCode && response.statusCode >= 200 && response.statusCode <= 299) {
                        resolve({ response: response, body: body });
                    }
                    else {
                        reject({ response: response, body: body });
                    }
                }
            });
        });
    };
    /**
     *
     * @summary Admin rever user billing plan to standard pricing
     * @param userId The id of the user whom will be reverted
     */
    DefaultApi.prototype.revertUserBillingPlan = function (userId) {
        var localVarPath = this.basePath + '/admin/billingPlan';
        var localVarQueryParameters = {};
        var localVarHeaderParams = Object.assign({}, this.defaultHeaders);
        var localVarFormParams = {};
        // verify required parameter 'userId' is not null or undefined
        if (userId === null || userId === undefined) {
            throw new Error('Required parameter userId was null or undefined when calling revertUserBillingPlan.');
        }
        if (userId !== undefined) {
            localVarQueryParameters['userId'] = ObjectSerializer.serialize(userId, "string");
        }
        var localVarUseFormData = false;
        var localVarRequestOptions = {
            method: 'DELETE',
            qs: localVarQueryParameters,
            headers: localVarHeaderParams,
            uri: localVarPath,
            useQuerystring: this._useQuerystring,
            json: true,
        };
        this.authentications.standard.applyToRequest(localVarRequestOptions);
        this.authentications.default.applyToRequest(localVarRequestOptions);
        if (Object.keys(localVarFormParams).length) {
            if (localVarUseFormData) {
                localVarRequestOptions.formData = localVarFormParams;
            }
            else {
                localVarRequestOptions.form = localVarFormParams;
            }
        }
        return new Promise(function (resolve, reject) {
            localVarRequest(localVarRequestOptions, function (error, response, body) {
                if (error) {
                    reject(error);
                }
                else {
                    body = ObjectSerializer.deserialize(body, "BillingPlan");
                    if (response.statusCode && response.statusCode >= 200 && response.statusCode <= 299) {
                        resolve({ response: response, body: body });
                    }
                    else {
                        reject({ response: response, body: body });
                    }
                }
            });
        });
    };
    /**
     *
     * @summary Sends a 6-digit verification code to the user email address.
     * @param verification ID of the filespace to be deleted.
     */
    DefaultApi.prototype.sendDeleteFilespaceVerificationCode = function (verification) {
        var localVarPath = this.basePath + '/verification/filespaceDelete';
        var localVarQueryParameters = {};
        var localVarHeaderParams = Object.assign({}, this.defaultHeaders);
        var localVarFormParams = {};
        var localVarUseFormData = false;
        var localVarRequestOptions = {
            method: 'POST',
            qs: localVarQueryParameters,
            headers: localVarHeaderParams,
            uri: localVarPath,
            useQuerystring: this._useQuerystring,
            json: true,
            body: ObjectSerializer.serialize(verification, "FilespaceDeleteAuth")
        };
        this.authentications.standard.applyToRequest(localVarRequestOptions);
        this.authentications.default.applyToRequest(localVarRequestOptions);
        if (Object.keys(localVarFormParams).length) {
            if (localVarUseFormData) {
                localVarRequestOptions.formData = localVarFormParams;
            }
            else {
                localVarRequestOptions.form = localVarFormParams;
            }
        }
        return new Promise(function (resolve, reject) {
            localVarRequest(localVarRequestOptions, function (error, response, body) {
                if (error) {
                    reject(error);
                }
                else {
                    if (response.statusCode && response.statusCode >= 200 && response.statusCode <= 299) {
                        resolve({ response: response, body: body });
                    }
                    else {
                        reject({ response: response, body: body });
                    }
                }
            });
        });
    };
    /**
     *
     * @summary Sends a 6-digit verification code to the user email address.
     * @param verification The verification object
     */
    DefaultApi.prototype.sendFilespaceVerificationCode = function (verification) {
        var localVarPath = this.basePath + '/verification/filespace';
        var localVarQueryParameters = {};
        var localVarHeaderParams = Object.assign({}, this.defaultHeaders);
        var localVarFormParams = {};
        var localVarUseFormData = false;
        var localVarRequestOptions = {
            method: 'POST',
            qs: localVarQueryParameters,
            headers: localVarHeaderParams,
            uri: localVarPath,
            useQuerystring: this._useQuerystring,
            json: true,
            body: ObjectSerializer.serialize(verification, "FilespaceAuth")
        };
        this.authentications.standard.applyToRequest(localVarRequestOptions);
        this.authentications.default.applyToRequest(localVarRequestOptions);
        if (Object.keys(localVarFormParams).length) {
            if (localVarUseFormData) {
                localVarRequestOptions.formData = localVarFormParams;
            }
            else {
                localVarRequestOptions.form = localVarFormParams;
            }
        }
        return new Promise(function (resolve, reject) {
            localVarRequest(localVarRequestOptions, function (error, response, body) {
                if (error) {
                    reject(error);
                }
                else {
                    if (response.statusCode && response.statusCode >= 200 && response.statusCode <= 299) {
                        resolve({ response: response, body: body });
                    }
                    else {
                        reject({ response: response, body: body });
                    }
                }
            });
        });
    };
    /**
     *
     * @summary Manually suspend a user based on their email
     * @param userId The id of the user to be suspended
     */
    DefaultApi.prototype.suspendUser = function (userId) {
        var localVarPath = this.basePath + '/admin/suspendUser';
        var localVarQueryParameters = {};
        var localVarHeaderParams = Object.assign({}, this.defaultHeaders);
        var localVarFormParams = {};
        // verify required parameter 'userId' is not null or undefined
        if (userId === null || userId === undefined) {
            throw new Error('Required parameter userId was null or undefined when calling suspendUser.');
        }
        if (userId !== undefined) {
            localVarQueryParameters['userId'] = ObjectSerializer.serialize(userId, "string");
        }
        var localVarUseFormData = false;
        var localVarRequestOptions = {
            method: 'GET',
            qs: localVarQueryParameters,
            headers: localVarHeaderParams,
            uri: localVarPath,
            useQuerystring: this._useQuerystring,
            json: true,
        };
        this.authentications.standard.applyToRequest(localVarRequestOptions);
        this.authentications.default.applyToRequest(localVarRequestOptions);
        if (Object.keys(localVarFormParams).length) {
            if (localVarUseFormData) {
                localVarRequestOptions.formData = localVarFormParams;
            }
            else {
                localVarRequestOptions.form = localVarFormParams;
            }
        }
        return new Promise(function (resolve, reject) {
            localVarRequest(localVarRequestOptions, function (error, response, body) {
                if (error) {
                    reject(error);
                }
                else {
                    if (response.statusCode && response.statusCode >= 200 && response.statusCode <= 299) {
                        resolve({ response: response, body: body });
                    }
                    else {
                        reject({ response: response, body: body });
                    }
                }
            });
        });
    };
    /**
     *
     * @summary Manually unsuspend a user based on their email
     * @param userId The id of the user to be unsuspended
     */
    DefaultApi.prototype.unsuspendUser = function (userId) {
        var localVarPath = this.basePath + '/admin/unsuspendUser';
        var localVarQueryParameters = {};
        var localVarHeaderParams = Object.assign({}, this.defaultHeaders);
        var localVarFormParams = {};
        // verify required parameter 'userId' is not null or undefined
        if (userId === null || userId === undefined) {
            throw new Error('Required parameter userId was null or undefined when calling unsuspendUser.');
        }
        if (userId !== undefined) {
            localVarQueryParameters['userId'] = ObjectSerializer.serialize(userId, "string");
        }
        var localVarUseFormData = false;
        var localVarRequestOptions = {
            method: 'GET',
            qs: localVarQueryParameters,
            headers: localVarHeaderParams,
            uri: localVarPath,
            useQuerystring: this._useQuerystring,
            json: true,
        };
        this.authentications.standard.applyToRequest(localVarRequestOptions);
        this.authentications.default.applyToRequest(localVarRequestOptions);
        if (Object.keys(localVarFormParams).length) {
            if (localVarUseFormData) {
                localVarRequestOptions.formData = localVarFormParams;
            }
            else {
                localVarRequestOptions.form = localVarFormParams;
            }
        }
        return new Promise(function (resolve, reject) {
            localVarRequest(localVarRequestOptions, function (error, response, body) {
                if (error) {
                    reject(error);
                }
                else {
                    if (response.statusCode && response.statusCode >= 200 && response.statusCode <= 299) {
                        resolve({ response: response, body: body });
                    }
                    else {
                        reject({ response: response, body: body });
                    }
                }
            });
        });
    };
    /**
     *
     * @summary Update user attributes
     * @param attributes Update Cognito/FreshSales attributes
     */
    DefaultApi.prototype.updateAttributes = function (attributes) {
        var localVarPath = this.basePath + '/attributes';
        var localVarQueryParameters = {};
        var localVarHeaderParams = Object.assign({}, this.defaultHeaders);
        var localVarFormParams = {};
        var localVarUseFormData = false;
        var localVarRequestOptions = {
            method: 'POST',
            qs: localVarQueryParameters,
            headers: localVarHeaderParams,
            uri: localVarPath,
            useQuerystring: this._useQuerystring,
            json: true,
            body: ObjectSerializer.serialize(attributes, "Attributes")
        };
        this.authentications.standard.applyToRequest(localVarRequestOptions);
        this.authentications.default.applyToRequest(localVarRequestOptions);
        if (Object.keys(localVarFormParams).length) {
            if (localVarUseFormData) {
                localVarRequestOptions.formData = localVarFormParams;
            }
            else {
                localVarRequestOptions.form = localVarFormParams;
            }
        }
        return new Promise(function (resolve, reject) {
            localVarRequest(localVarRequestOptions, function (error, response, body) {
                if (error) {
                    reject(error);
                }
                else {
                    if (response.statusCode && response.statusCode >= 200 && response.statusCode <= 299) {
                        resolve({ response: response, body: body });
                    }
                    else {
                        reject({ response: response, body: body });
                    }
                }
            });
        });
    };
    /**
     *
     * @summary Admin enable or disable billing for a filespace
     * @param filespaceId Filespace id
     * @param isBillingEnabled Billing enabled state for filespace
     */
    DefaultApi.prototype.updateIsBillingEnabled = function (filespaceId, isBillingEnabled) {
        var localVarPath = this.basePath + '/admin/isBillingEnabled';
        var localVarQueryParameters = {};
        var localVarHeaderParams = Object.assign({}, this.defaultHeaders);
        var localVarFormParams = {};
        // verify required parameter 'filespaceId' is not null or undefined
        if (filespaceId === null || filespaceId === undefined) {
            throw new Error('Required parameter filespaceId was null or undefined when calling updateIsBillingEnabled.');
        }
        // verify required parameter 'isBillingEnabled' is not null or undefined
        if (isBillingEnabled === null || isBillingEnabled === undefined) {
            throw new Error('Required parameter isBillingEnabled was null or undefined when calling updateIsBillingEnabled.');
        }
        if (filespaceId !== undefined) {
            localVarQueryParameters['filespaceId'] = ObjectSerializer.serialize(filespaceId, "string");
        }
        if (isBillingEnabled !== undefined) {
            localVarQueryParameters['isBillingEnabled'] = ObjectSerializer.serialize(isBillingEnabled, "boolean");
        }
        var localVarUseFormData = false;
        var localVarRequestOptions = {
            method: 'PATCH',
            qs: localVarQueryParameters,
            headers: localVarHeaderParams,
            uri: localVarPath,
            useQuerystring: this._useQuerystring,
            json: true,
        };
        this.authentications.standard.applyToRequest(localVarRequestOptions);
        this.authentications.default.applyToRequest(localVarRequestOptions);
        if (Object.keys(localVarFormParams).length) {
            if (localVarUseFormData) {
                localVarRequestOptions.formData = localVarFormParams;
            }
            else {
                localVarRequestOptions.form = localVarFormParams;
            }
        }
        return new Promise(function (resolve, reject) {
            localVarRequest(localVarRequestOptions, function (error, response, body) {
                if (error) {
                    reject(error);
                }
                else {
                    if (response.statusCode && response.statusCode >= 200 && response.statusCode <= 299) {
                        resolve({ response: response, body: body });
                    }
                    else {
                        reject({ response: response, body: body });
                    }
                }
            });
        });
    };
    /**
     *
     * @summary Admin update user billing plan
     * @param userId The id of the user whom will be updated
     * @param body Billing plan updates
     */
    DefaultApi.prototype.updateUserBillingPlan = function (userId, body) {
        var localVarPath = this.basePath + '/admin/billingPlan';
        var localVarQueryParameters = {};
        var localVarHeaderParams = Object.assign({}, this.defaultHeaders);
        var localVarFormParams = {};
        // verify required parameter 'userId' is not null or undefined
        if (userId === null || userId === undefined) {
            throw new Error('Required parameter userId was null or undefined when calling updateUserBillingPlan.');
        }
        // verify required parameter 'body' is not null or undefined
        if (body === null || body === undefined) {
            throw new Error('Required parameter body was null or undefined when calling updateUserBillingPlan.');
        }
        if (userId !== undefined) {
            localVarQueryParameters['userId'] = ObjectSerializer.serialize(userId, "string");
        }
        var localVarUseFormData = false;
        var localVarRequestOptions = {
            method: 'PATCH',
            qs: localVarQueryParameters,
            headers: localVarHeaderParams,
            uri: localVarPath,
            useQuerystring: this._useQuerystring,
            json: true,
            body: ObjectSerializer.serialize(body, "BillingPlanUpdate")
        };
        this.authentications.standard.applyToRequest(localVarRequestOptions);
        this.authentications.default.applyToRequest(localVarRequestOptions);
        if (Object.keys(localVarFormParams).length) {
            if (localVarUseFormData) {
                localVarRequestOptions.formData = localVarFormParams;
            }
            else {
                localVarRequestOptions.form = localVarFormParams;
            }
        }
        return new Promise(function (resolve, reject) {
            localVarRequest(localVarRequestOptions, function (error, response, body) {
                if (error) {
                    reject(error);
                }
                else {
                    body = ObjectSerializer.deserialize(body, "BillingPlan");
                    if (response.statusCode && response.statusCode >= 200 && response.statusCode <= 299) {
                        resolve({ response: response, body: body });
                    }
                    else {
                        reject({ response: response, body: body });
                    }
                }
            });
        });
    };
    /**
     *
     * @summary Update user's email.
     * @param id ID of the user
     * @param body Email string to update with.
     */
    DefaultApi.prototype.updateUserEmail = function (id, body) {
        var localVarPath = this.basePath + '/admin/users/{id}'
            .replace('{' + 'id' + '}', encodeURIComponent(String(id)));
        var localVarQueryParameters = {};
        var localVarHeaderParams = Object.assign({}, this.defaultHeaders);
        var localVarFormParams = {};
        // verify required parameter 'id' is not null or undefined
        if (id === null || id === undefined) {
            throw new Error('Required parameter id was null or undefined when calling updateUserEmail.');
        }
        // verify required parameter 'body' is not null or undefined
        if (body === null || body === undefined) {
            throw new Error('Required parameter body was null or undefined when calling updateUserEmail.');
        }
        var localVarUseFormData = false;
        var localVarRequestOptions = {
            method: 'PATCH',
            qs: localVarQueryParameters,
            headers: localVarHeaderParams,
            uri: localVarPath,
            useQuerystring: this._useQuerystring,
            json: true,
            body: ObjectSerializer.serialize(body, "UserEmail")
        };
        this.authentications.standard.applyToRequest(localVarRequestOptions);
        this.authentications.default.applyToRequest(localVarRequestOptions);
        if (Object.keys(localVarFormParams).length) {
            if (localVarUseFormData) {
                localVarRequestOptions.formData = localVarFormParams;
            }
            else {
                localVarRequestOptions.form = localVarFormParams;
            }
        }
        return new Promise(function (resolve, reject) {
            localVarRequest(localVarRequestOptions, function (error, response, body) {
                if (error) {
                    reject(error);
                }
                else {
                    if (response.statusCode && response.statusCode >= 200 && response.statusCode <= 299) {
                        resolve({ response: response, body: body });
                    }
                    else {
                        reject({ response: response, body: body });
                    }
                }
            });
        });
    };
    return DefaultApi;
}());
exports.DefaultApi = DefaultApi;
var DomainApiApiKeys;
(function (DomainApiApiKeys) {
})(DomainApiApiKeys = exports.DomainApiApiKeys || (exports.DomainApiApiKeys = {}));
var DomainApi = /** @class */ (function () {
    function DomainApi(basePathOrUsername, password, basePath) {
        this._basePath = defaultBasePath;
        this.defaultHeaders = {};
        this._useQuerystring = false;
        this.authentications = {
            'default': new VoidAuth(),
            'standard': new OAuth(),
        };
        if (password) {
            if (basePath) {
                this.basePath = basePath;
            }
        }
        else {
            if (basePathOrUsername) {
                this.basePath = basePathOrUsername;
            }
        }
    }
    Object.defineProperty(DomainApi.prototype, "useQuerystring", {
        set: function (value) {
            this._useQuerystring = value;
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(DomainApi.prototype, "basePath", {
        get: function () {
            return this._basePath;
        },
        set: function (basePath) {
            this._basePath = basePath;
        },
        enumerable: true,
        configurable: true
    });
    DomainApi.prototype.setDefaultAuthentication = function (auth) {
        this.authentications.default = auth;
    };
    DomainApi.prototype.setApiKey = function (key, value) {
        this.authentications[DomainApiApiKeys[key]].apiKey = value;
    };
    Object.defineProperty(DomainApi.prototype, "accessToken", {
        set: function (token) {
            this.authentications.standard.accessToken = token;
        },
        enumerable: true,
        configurable: true
    });
    /**
     *
     * @summary Create a domain.
     * @param body Domain object to be created. Domains are globally unique across all LucidLink accounts.
     */
    DomainApi.prototype.createDomain = function (body) {
        var localVarPath = this.basePath + '/domains';
        var localVarQueryParameters = {};
        var localVarHeaderParams = Object.assign({}, this.defaultHeaders);
        var localVarFormParams = {};
        // verify required parameter 'body' is not null or undefined
        if (body === null || body === undefined) {
            throw new Error('Required parameter body was null or undefined when calling createDomain.');
        }
        var localVarUseFormData = false;
        var localVarRequestOptions = {
            method: 'POST',
            qs: localVarQueryParameters,
            headers: localVarHeaderParams,
            uri: localVarPath,
            useQuerystring: this._useQuerystring,
            json: true,
            body: ObjectSerializer.serialize(body, "Domain")
        };
        this.authentications.standard.applyToRequest(localVarRequestOptions);
        this.authentications.default.applyToRequest(localVarRequestOptions);
        if (Object.keys(localVarFormParams).length) {
            if (localVarUseFormData) {
                localVarRequestOptions.formData = localVarFormParams;
            }
            else {
                localVarRequestOptions.form = localVarFormParams;
            }
        }
        return new Promise(function (resolve, reject) {
            localVarRequest(localVarRequestOptions, function (error, response, body) {
                if (error) {
                    reject(error);
                }
                else {
                    body = ObjectSerializer.deserialize(body, "Domain");
                    if (response.statusCode && response.statusCode >= 200 && response.statusCode <= 299) {
                        resolve({ response: response, body: body });
                    }
                    else {
                        reject({ response: response, body: body });
                    }
                }
            });
        });
    };
    /**
     *
     * @summary Delete a domain.
     * @param id ID of the domain to be deleted.
     */
    DomainApi.prototype.deleteDomain = function (id) {
        var localVarPath = this.basePath + '/domains/{id}'
            .replace('{' + 'id' + '}', encodeURIComponent(String(id)));
        var localVarQueryParameters = {};
        var localVarHeaderParams = Object.assign({}, this.defaultHeaders);
        var localVarFormParams = {};
        // verify required parameter 'id' is not null or undefined
        if (id === null || id === undefined) {
            throw new Error('Required parameter id was null or undefined when calling deleteDomain.');
        }
        var localVarUseFormData = false;
        var localVarRequestOptions = {
            method: 'DELETE',
            qs: localVarQueryParameters,
            headers: localVarHeaderParams,
            uri: localVarPath,
            useQuerystring: this._useQuerystring,
            json: true,
        };
        this.authentications.standard.applyToRequest(localVarRequestOptions);
        this.authentications.default.applyToRequest(localVarRequestOptions);
        if (Object.keys(localVarFormParams).length) {
            if (localVarUseFormData) {
                localVarRequestOptions.formData = localVarFormParams;
            }
            else {
                localVarRequestOptions.form = localVarFormParams;
            }
        }
        return new Promise(function (resolve, reject) {
            localVarRequest(localVarRequestOptions, function (error, response, body) {
                if (error) {
                    reject(error);
                }
                else {
                    if (response.statusCode && response.statusCode >= 200 && response.statusCode <= 299) {
                        resolve({ response: response, body: body });
                    }
                    else {
                        reject({ response: response, body: body });
                    }
                }
            });
        });
    };
    /**
     *
     * @summary Retrieve a domain.
     * @param id ID of the domain to be retrieved.
     */
    DomainApi.prototype.getDomain = function (id) {
        var localVarPath = this.basePath + '/domains/{id}'
            .replace('{' + 'id' + '}', encodeURIComponent(String(id)));
        var localVarQueryParameters = {};
        var localVarHeaderParams = Object.assign({}, this.defaultHeaders);
        var localVarFormParams = {};
        // verify required parameter 'id' is not null or undefined
        if (id === null || id === undefined) {
            throw new Error('Required parameter id was null or undefined when calling getDomain.');
        }
        var localVarUseFormData = false;
        var localVarRequestOptions = {
            method: 'GET',
            qs: localVarQueryParameters,
            headers: localVarHeaderParams,
            uri: localVarPath,
            useQuerystring: this._useQuerystring,
            json: true,
        };
        this.authentications.standard.applyToRequest(localVarRequestOptions);
        this.authentications.default.applyToRequest(localVarRequestOptions);
        if (Object.keys(localVarFormParams).length) {
            if (localVarUseFormData) {
                localVarRequestOptions.formData = localVarFormParams;
            }
            else {
                localVarRequestOptions.form = localVarFormParams;
            }
        }
        return new Promise(function (resolve, reject) {
            localVarRequest(localVarRequestOptions, function (error, response, body) {
                if (error) {
                    reject(error);
                }
                else {
                    body = ObjectSerializer.deserialize(body, "Domain");
                    if (response.statusCode && response.statusCode >= 200 && response.statusCode <= 299) {
                        resolve({ response: response, body: body });
                    }
                    else {
                        reject({ response: response, body: body });
                    }
                }
            });
        });
    };
    /**
     *
     * @summary Get a list of domains.
     */
    DomainApi.prototype.getDomains = function () {
        var localVarPath = this.basePath + '/domains';
        var localVarQueryParameters = {};
        var localVarHeaderParams = Object.assign({}, this.defaultHeaders);
        var localVarFormParams = {};
        var localVarUseFormData = false;
        var localVarRequestOptions = {
            method: 'GET',
            qs: localVarQueryParameters,
            headers: localVarHeaderParams,
            uri: localVarPath,
            useQuerystring: this._useQuerystring,
            json: true,
        };
        this.authentications.standard.applyToRequest(localVarRequestOptions);
        this.authentications.default.applyToRequest(localVarRequestOptions);
        if (Object.keys(localVarFormParams).length) {
            if (localVarUseFormData) {
                localVarRequestOptions.formData = localVarFormParams;
            }
            else {
                localVarRequestOptions.form = localVarFormParams;
            }
        }
        return new Promise(function (resolve, reject) {
            localVarRequest(localVarRequestOptions, function (error, response, body) {
                if (error) {
                    reject(error);
                }
                else {
                    body = ObjectSerializer.deserialize(body, "Array<Domain>");
                    if (response.statusCode && response.statusCode >= 200 && response.statusCode <= 299) {
                        resolve({ response: response, body: body });
                    }
                    else {
                        reject({ response: response, body: body });
                    }
                }
            });
        });
    };
    /**
     *
     * @summary Update a domain.
     * @param id ID of the domain to be updated.
     * @param body Domain object to update with.
     */
    DomainApi.prototype.updateDomain = function (id, body) {
        var localVarPath = this.basePath + '/domains/{id}'
            .replace('{' + 'id' + '}', encodeURIComponent(String(id)));
        var localVarQueryParameters = {};
        var localVarHeaderParams = Object.assign({}, this.defaultHeaders);
        var localVarFormParams = {};
        // verify required parameter 'id' is not null or undefined
        if (id === null || id === undefined) {
            throw new Error('Required parameter id was null or undefined when calling updateDomain.');
        }
        // verify required parameter 'body' is not null or undefined
        if (body === null || body === undefined) {
            throw new Error('Required parameter body was null or undefined when calling updateDomain.');
        }
        var localVarUseFormData = false;
        var localVarRequestOptions = {
            method: 'PUT',
            qs: localVarQueryParameters,
            headers: localVarHeaderParams,
            uri: localVarPath,
            useQuerystring: this._useQuerystring,
            json: true,
            body: ObjectSerializer.serialize(body, "Domain")
        };
        this.authentications.standard.applyToRequest(localVarRequestOptions);
        this.authentications.default.applyToRequest(localVarRequestOptions);
        if (Object.keys(localVarFormParams).length) {
            if (localVarUseFormData) {
                localVarRequestOptions.formData = localVarFormParams;
            }
            else {
                localVarRequestOptions.form = localVarFormParams;
            }
        }
        return new Promise(function (resolve, reject) {
            localVarRequest(localVarRequestOptions, function (error, response, body) {
                if (error) {
                    reject(error);
                }
                else {
                    body = ObjectSerializer.deserialize(body, "Domain");
                    if (response.statusCode && response.statusCode >= 200 && response.statusCode <= 299) {
                        resolve({ response: response, body: body });
                    }
                    else {
                        reject({ response: response, body: body });
                    }
                }
            });
        });
    };
    return DomainApi;
}());
exports.DomainApi = DomainApi;
var FilespaceApiApiKeys;
(function (FilespaceApiApiKeys) {
})(FilespaceApiApiKeys = exports.FilespaceApiApiKeys || (exports.FilespaceApiApiKeys = {}));
var FilespaceApi = /** @class */ (function () {
    function FilespaceApi(basePathOrUsername, password, basePath) {
        this._basePath = defaultBasePath;
        this.defaultHeaders = {};
        this._useQuerystring = false;
        this.authentications = {
            'default': new VoidAuth(),
            'standard': new OAuth(),
        };
        if (password) {
            if (basePath) {
                this.basePath = basePath;
            }
        }
        else {
            if (basePathOrUsername) {
                this.basePath = basePathOrUsername;
            }
        }
    }
    Object.defineProperty(FilespaceApi.prototype, "useQuerystring", {
        set: function (value) {
            this._useQuerystring = value;
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(FilespaceApi.prototype, "basePath", {
        get: function () {
            return this._basePath;
        },
        set: function (basePath) {
            this._basePath = basePath;
        },
        enumerable: true,
        configurable: true
    });
    FilespaceApi.prototype.setDefaultAuthentication = function (auth) {
        this.authentications.default = auth;
    };
    FilespaceApi.prototype.setApiKey = function (key, value) {
        this.authentications[FilespaceApiApiKeys[key]].apiKey = value;
    };
    Object.defineProperty(FilespaceApi.prototype, "accessToken", {
        set: function (token) {
            this.authentications.standard.accessToken = token;
        },
        enumerable: true,
        configurable: true
    });
    /**
     *
     * @summary Create a filespace.
     * @param body Filespace object to be created
     */
    FilespaceApi.prototype.createFilespace = function (body) {
        var localVarPath = this.basePath + '/filespaces';
        var localVarQueryParameters = {};
        var localVarHeaderParams = Object.assign({}, this.defaultHeaders);
        var localVarFormParams = {};
        // verify required parameter 'body' is not null or undefined
        if (body === null || body === undefined) {
            throw new Error('Required parameter body was null or undefined when calling createFilespace.');
        }
        var localVarUseFormData = false;
        var localVarRequestOptions = {
            method: 'POST',
            qs: localVarQueryParameters,
            headers: localVarHeaderParams,
            uri: localVarPath,
            useQuerystring: this._useQuerystring,
            json: true,
            body: ObjectSerializer.serialize(body, "Filespace")
        };
        this.authentications.standard.applyToRequest(localVarRequestOptions);
        this.authentications.default.applyToRequest(localVarRequestOptions);
        if (Object.keys(localVarFormParams).length) {
            if (localVarUseFormData) {
                localVarRequestOptions.formData = localVarFormParams;
            }
            else {
                localVarRequestOptions.form = localVarFormParams;
            }
        }
        return new Promise(function (resolve, reject) {
            localVarRequest(localVarRequestOptions, function (error, response, body) {
                if (error) {
                    reject(error);
                }
                else {
                    body = ObjectSerializer.deserialize(body, "Filespace");
                    if (response.statusCode && response.statusCode >= 200 && response.statusCode <= 299) {
                        resolve({ response: response, body: body });
                    }
                    else {
                        reject({ response: response, body: body });
                    }
                }
            });
        });
    };
    /**
     *
     * @summary Delete a filespace.
     * @param id ID of the filespace to be deleted.
     * @param verificationCode Verification code.
     */
    FilespaceApi.prototype.deleteFilespace = function (id, verificationCode) {
        var localVarPath = this.basePath + '/filespaces/{id}'
            .replace('{' + 'id' + '}', encodeURIComponent(String(id)));
        var localVarQueryParameters = {};
        var localVarHeaderParams = Object.assign({}, this.defaultHeaders);
        var localVarFormParams = {};
        // verify required parameter 'id' is not null or undefined
        if (id === null || id === undefined) {
            throw new Error('Required parameter id was null or undefined when calling deleteFilespace.');
        }
        var localVarUseFormData = false;
        var localVarRequestOptions = {
            method: 'DELETE',
            qs: localVarQueryParameters,
            headers: localVarHeaderParams,
            uri: localVarPath,
            useQuerystring: this._useQuerystring,
            json: true,
            body: ObjectSerializer.serialize(verificationCode, "VerificationCode")
        };
        this.authentications.standard.applyToRequest(localVarRequestOptions);
        this.authentications.default.applyToRequest(localVarRequestOptions);
        if (Object.keys(localVarFormParams).length) {
            if (localVarUseFormData) {
                localVarRequestOptions.formData = localVarFormParams;
            }
            else {
                localVarRequestOptions.form = localVarFormParams;
            }
        }
        return new Promise(function (resolve, reject) {
            localVarRequest(localVarRequestOptions, function (error, response, body) {
                if (error) {
                    reject(error);
                }
                else {
                    if (response.statusCode && response.statusCode >= 200 && response.statusCode <= 299) {
                        resolve({ response: response, body: body });
                    }
                    else {
                        reject({ response: response, body: body });
                    }
                }
            });
        });
    };
    /**
     *
     * @summary Get a list of filespaces.
     */
    FilespaceApi.prototype.getDisabledRegions = function () {
        var localVarPath = this.basePath + '/filespaces/disabled-regions';
        var localVarQueryParameters = {};
        var localVarHeaderParams = Object.assign({}, this.defaultHeaders);
        var localVarFormParams = {};
        var localVarUseFormData = false;
        var localVarRequestOptions = {
            method: 'GET',
            qs: localVarQueryParameters,
            headers: localVarHeaderParams,
            uri: localVarPath,
            useQuerystring: this._useQuerystring,
            json: true,
        };
        this.authentications.standard.applyToRequest(localVarRequestOptions);
        this.authentications.default.applyToRequest(localVarRequestOptions);
        if (Object.keys(localVarFormParams).length) {
            if (localVarUseFormData) {
                localVarRequestOptions.formData = localVarFormParams;
            }
            else {
                localVarRequestOptions.form = localVarFormParams;
            }
        }
        return new Promise(function (resolve, reject) {
            localVarRequest(localVarRequestOptions, function (error, response, body) {
                if (error) {
                    reject(error);
                }
                else {
                    body = ObjectSerializer.deserialize(body, "Array<FilespaceS3Region>");
                    if (response.statusCode && response.statusCode >= 200 && response.statusCode <= 299) {
                        resolve({ response: response, body: body });
                    }
                    else {
                        reject({ response: response, body: body });
                    }
                }
            });
        });
    };
    /**
     *
     * @summary Retrieve a filespace.
     * @param id ID of the filespace to be retrieved.
     */
    FilespaceApi.prototype.getFilespace = function (id) {
        var localVarPath = this.basePath + '/filespaces/{id}'
            .replace('{' + 'id' + '}', encodeURIComponent(String(id)));
        var localVarQueryParameters = {};
        var localVarHeaderParams = Object.assign({}, this.defaultHeaders);
        var localVarFormParams = {};
        // verify required parameter 'id' is not null or undefined
        if (id === null || id === undefined) {
            throw new Error('Required parameter id was null or undefined when calling getFilespace.');
        }
        var localVarUseFormData = false;
        var localVarRequestOptions = {
            method: 'GET',
            qs: localVarQueryParameters,
            headers: localVarHeaderParams,
            uri: localVarPath,
            useQuerystring: this._useQuerystring,
            json: true,
        };
        this.authentications.standard.applyToRequest(localVarRequestOptions);
        this.authentications.default.applyToRequest(localVarRequestOptions);
        if (Object.keys(localVarFormParams).length) {
            if (localVarUseFormData) {
                localVarRequestOptions.formData = localVarFormParams;
            }
            else {
                localVarRequestOptions.form = localVarFormParams;
            }
        }
        return new Promise(function (resolve, reject) {
            localVarRequest(localVarRequestOptions, function (error, response, body) {
                if (error) {
                    reject(error);
                }
                else {
                    body = ObjectSerializer.deserialize(body, "Filespace");
                    if (response.statusCode && response.statusCode >= 200 && response.statusCode <= 299) {
                        resolve({ response: response, body: body });
                    }
                    else {
                        reject({ response: response, body: body });
                    }
                }
            });
        });
    };
    /**
     *
     * @summary Get a list of filespaces.
     * @param qualifiedName Fully-qualified name of a filespace to search for.
     */
    FilespaceApi.prototype.getFilespaces = function (qualifiedName) {
        var localVarPath = this.basePath + '/filespaces';
        var localVarQueryParameters = {};
        var localVarHeaderParams = Object.assign({}, this.defaultHeaders);
        var localVarFormParams = {};
        if (qualifiedName !== undefined) {
            localVarQueryParameters['qualifiedName'] = ObjectSerializer.serialize(qualifiedName, "string");
        }
        var localVarUseFormData = false;
        var localVarRequestOptions = {
            method: 'GET',
            qs: localVarQueryParameters,
            headers: localVarHeaderParams,
            uri: localVarPath,
            useQuerystring: this._useQuerystring,
            json: true,
        };
        this.authentications.standard.applyToRequest(localVarRequestOptions);
        this.authentications.default.applyToRequest(localVarRequestOptions);
        if (Object.keys(localVarFormParams).length) {
            if (localVarUseFormData) {
                localVarRequestOptions.formData = localVarFormParams;
            }
            else {
                localVarRequestOptions.form = localVarFormParams;
            }
        }
        return new Promise(function (resolve, reject) {
            localVarRequest(localVarRequestOptions, function (error, response, body) {
                if (error) {
                    reject(error);
                }
                else {
                    body = ObjectSerializer.deserialize(body, "Array<Filespace>");
                    if (response.statusCode && response.statusCode >= 200 && response.statusCode <= 299) {
                        resolve({ response: response, body: body });
                    }
                    else {
                        reject({ response: response, body: body });
                    }
                }
            });
        });
    };
    /**
     *
     * @summary Re-issue a certificate when renaming a filespace
     * @param body Object containing base64 encoded CSR
     */
    FilespaceApi.prototype.issueCertificate = function (body) {
        var localVarPath = this.basePath + '/filespaces/csr';
        var localVarQueryParameters = {};
        var localVarHeaderParams = Object.assign({}, this.defaultHeaders);
        var localVarFormParams = {};
        // verify required parameter 'body' is not null or undefined
        if (body === null || body === undefined) {
            throw new Error('Required parameter body was null or undefined when calling issueCertificate.');
        }
        var localVarUseFormData = false;
        var localVarRequestOptions = {
            method: 'POST',
            qs: localVarQueryParameters,
            headers: localVarHeaderParams,
            uri: localVarPath,
            useQuerystring: this._useQuerystring,
            json: true,
            body: ObjectSerializer.serialize(body, "CertificateSigningRequest")
        };
        this.authentications.standard.applyToRequest(localVarRequestOptions);
        this.authentications.default.applyToRequest(localVarRequestOptions);
        if (Object.keys(localVarFormParams).length) {
            if (localVarUseFormData) {
                localVarRequestOptions.formData = localVarFormParams;
            }
            else {
                localVarRequestOptions.form = localVarFormParams;
            }
        }
        return new Promise(function (resolve, reject) {
            localVarRequest(localVarRequestOptions, function (error, response, body) {
                if (error) {
                    reject(error);
                }
                else {
                    body = ObjectSerializer.deserialize(body, "CertificateSigningResponse");
                    if (response.statusCode && response.statusCode >= 200 && response.statusCode <= 299) {
                        resolve({ response: response, body: body });
                    }
                    else {
                        reject({ response: response, body: body });
                    }
                }
            });
        });
    };
    /**
     *
     * @summary Revoke old accessKeyId
     * @param fsId the provisioned Filespace fsId
     * @param body { revokedKey: oldCredentials.accessKeyId, activeKey: newCredentials.accessKeyId }
     */
    FilespaceApi.prototype.remoteRekey = function (fsId, body) {
        var localVarPath = this.basePath + '/filespaces/remoteRekey/{fsId}'
            .replace('{' + 'fsId' + '}', encodeURIComponent(String(fsId)));
        var localVarQueryParameters = {};
        var localVarHeaderParams = Object.assign({}, this.defaultHeaders);
        var localVarFormParams = {};
        // verify required parameter 'fsId' is not null or undefined
        if (fsId === null || fsId === undefined) {
            throw new Error('Required parameter fsId was null or undefined when calling remoteRekey.');
        }
        var localVarUseFormData = false;
        var localVarRequestOptions = {
            method: 'PUT',
            qs: localVarQueryParameters,
            headers: localVarHeaderParams,
            uri: localVarPath,
            useQuerystring: this._useQuerystring,
            json: true,
            body: ObjectSerializer.serialize(body, "RemoteRekeyPayload")
        };
        this.authentications.standard.applyToRequest(localVarRequestOptions);
        this.authentications.default.applyToRequest(localVarRequestOptions);
        if (Object.keys(localVarFormParams).length) {
            if (localVarUseFormData) {
                localVarRequestOptions.formData = localVarFormParams;
            }
            else {
                localVarRequestOptions.form = localVarFormParams;
            }
        }
        return new Promise(function (resolve, reject) {
            localVarRequest(localVarRequestOptions, function (error, response, body) {
                if (error) {
                    reject(error);
                }
                else {
                    if (response.statusCode && response.statusCode >= 200 && response.statusCode <= 299) {
                        resolve({ response: response, body: body });
                    }
                    else {
                        reject({ response: response, body: body });
                    }
                }
            });
        });
    };
    /**
     *
     * @summary Rename a filespace.
     * @param id ID of the filespace to be updated.
     * @param name New name for target filespace
     * @param verificationCode Verification code.
     */
    FilespaceApi.prototype.renameFilespace = function (id, name, verificationCode) {
        var localVarPath = this.basePath + '/filespaces/{id}/actions/rename'
            .replace('{' + 'id' + '}', encodeURIComponent(String(id)));
        var localVarQueryParameters = {};
        var localVarHeaderParams = Object.assign({}, this.defaultHeaders);
        var localVarFormParams = {};
        // verify required parameter 'id' is not null or undefined
        if (id === null || id === undefined) {
            throw new Error('Required parameter id was null or undefined when calling renameFilespace.');
        }
        // verify required parameter 'name' is not null or undefined
        if (name === null || name === undefined) {
            throw new Error('Required parameter name was null or undefined when calling renameFilespace.');
        }
        if (name !== undefined) {
            localVarQueryParameters['name'] = ObjectSerializer.serialize(name, "string");
        }
        var localVarUseFormData = false;
        var localVarRequestOptions = {
            method: 'PATCH',
            qs: localVarQueryParameters,
            headers: localVarHeaderParams,
            uri: localVarPath,
            useQuerystring: this._useQuerystring,
            json: true,
            body: ObjectSerializer.serialize(verificationCode, "VerificationCode")
        };
        this.authentications.standard.applyToRequest(localVarRequestOptions);
        this.authentications.default.applyToRequest(localVarRequestOptions);
        if (Object.keys(localVarFormParams).length) {
            if (localVarUseFormData) {
                localVarRequestOptions.formData = localVarFormParams;
            }
            else {
                localVarRequestOptions.form = localVarFormParams;
            }
        }
        return new Promise(function (resolve, reject) {
            localVarRequest(localVarRequestOptions, function (error, response, body) {
                if (error) {
                    reject(error);
                }
                else {
                    body = ObjectSerializer.deserialize(body, "Filespace");
                    if (response.statusCode && response.statusCode >= 200 && response.statusCode <= 299) {
                        resolve({ response: response, body: body });
                    }
                    else {
                        reject({ response: response, body: body });
                    }
                }
            });
        });
    };
    /**
     *
     * @summary Update a filespace.
     * @param id ID of the filespace to be updated.
     * @param body An object specifying filespace object fields to update.
     */
    FilespaceApi.prototype.updateFilespace = function (id, body) {
        var localVarPath = this.basePath + '/filespaces/{id}'
            .replace('{' + 'id' + '}', encodeURIComponent(String(id)));
        var localVarQueryParameters = {};
        var localVarHeaderParams = Object.assign({}, this.defaultHeaders);
        var localVarFormParams = {};
        // verify required parameter 'id' is not null or undefined
        if (id === null || id === undefined) {
            throw new Error('Required parameter id was null or undefined when calling updateFilespace.');
        }
        // verify required parameter 'body' is not null or undefined
        if (body === null || body === undefined) {
            throw new Error('Required parameter body was null or undefined when calling updateFilespace.');
        }
        var localVarUseFormData = false;
        var localVarRequestOptions = {
            method: 'PATCH',
            qs: localVarQueryParameters,
            headers: localVarHeaderParams,
            uri: localVarPath,
            useQuerystring: this._useQuerystring,
            json: true,
            body: ObjectSerializer.serialize(body, "any")
        };
        this.authentications.standard.applyToRequest(localVarRequestOptions);
        this.authentications.default.applyToRequest(localVarRequestOptions);
        if (Object.keys(localVarFormParams).length) {
            if (localVarUseFormData) {
                localVarRequestOptions.formData = localVarFormParams;
            }
            else {
                localVarRequestOptions.form = localVarFormParams;
            }
        }
        return new Promise(function (resolve, reject) {
            localVarRequest(localVarRequestOptions, function (error, response, body) {
                if (error) {
                    reject(error);
                }
                else {
                    body = ObjectSerializer.deserialize(body, "Filespace");
                    if (response.statusCode && response.statusCode >= 200 && response.statusCode <= 299) {
                        resolve({ response: response, body: body });
                    }
                    else {
                        reject({ response: response, body: body });
                    }
                }
            });
        });
    };
    return FilespaceApi;
}());
exports.FilespaceApi = FilespaceApi;
var NosecurityApiApiKeys;
(function (NosecurityApiApiKeys) {
})(NosecurityApiApiKeys = exports.NosecurityApiApiKeys || (exports.NosecurityApiApiKeys = {}));
var NosecurityApi = /** @class */ (function () {
    function NosecurityApi(basePathOrUsername, password, basePath) {
        this._basePath = defaultBasePath;
        this.defaultHeaders = {};
        this._useQuerystring = false;
        this.authentications = {
            'default': new VoidAuth(),
            'standard': new OAuth(),
        };
        if (password) {
            if (basePath) {
                this.basePath = basePath;
            }
        }
        else {
            if (basePathOrUsername) {
                this.basePath = basePathOrUsername;
            }
        }
    }
    Object.defineProperty(NosecurityApi.prototype, "useQuerystring", {
        set: function (value) {
            this._useQuerystring = value;
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(NosecurityApi.prototype, "basePath", {
        get: function () {
            return this._basePath;
        },
        set: function (basePath) {
            this._basePath = basePath;
        },
        enumerable: true,
        configurable: true
    });
    NosecurityApi.prototype.setDefaultAuthentication = function (auth) {
        this.authentications.default = auth;
    };
    NosecurityApi.prototype.setApiKey = function (key, value) {
        this.authentications[NosecurityApiApiKeys[key]].apiKey = value;
    };
    Object.defineProperty(NosecurityApi.prototype, "accessToken", {
        set: function (token) {
            this.authentications.standard.accessToken = token;
        },
        enumerable: true,
        configurable: true
    });
    /**
     *
     * @summary Send an unauthenticated message to be distributed to a notification system
     * @param message Message to be emitted
     */
    NosecurityApi.prototype.emit = function (message) {
        var localVarPath = this.basePath + '/events';
        var localVarQueryParameters = {};
        var localVarHeaderParams = Object.assign({}, this.defaultHeaders);
        var localVarFormParams = {};
        // verify required parameter 'message' is not null or undefined
        if (message === null || message === undefined) {
            throw new Error('Required parameter message was null or undefined when calling emit.');
        }
        var localVarUseFormData = false;
        var localVarRequestOptions = {
            method: 'POST',
            qs: localVarQueryParameters,
            headers: localVarHeaderParams,
            uri: localVarPath,
            useQuerystring: this._useQuerystring,
            json: true,
            body: ObjectSerializer.serialize(message, "Event")
        };
        this.authentications.default.applyToRequest(localVarRequestOptions);
        if (Object.keys(localVarFormParams).length) {
            if (localVarUseFormData) {
                localVarRequestOptions.formData = localVarFormParams;
            }
            else {
                localVarRequestOptions.form = localVarFormParams;
            }
        }
        return new Promise(function (resolve, reject) {
            localVarRequest(localVarRequestOptions, function (error, response, body) {
                if (error) {
                    reject(error);
                }
                else {
                    body = ObjectSerializer.deserialize(body, "any");
                    if (response.statusCode && response.statusCode >= 200 && response.statusCode <= 299) {
                        resolve({ response: response, body: body });
                    }
                    else {
                        reject({ response: response, body: body });
                    }
                }
            });
        });
    };
    return NosecurityApi;
}());
exports.NosecurityApi = NosecurityApi;
//# sourceMappingURL=api.js.map


//////////////////
// WEBPACK FOOTER
// ./node_modules/fs-api-client/dist/api.js
// module id = 6
// module chunks = 1